import { $n as CollectionRegistryContext, $t as getCollectionBySlugWithin, A as getFieldId, An as ReadOnlyFieldBinding, Ar as getIconForWidget, At as convertDataToEntity, B as MapFieldBinding, Bn as MapPropertyPreview, Bt as detectCsvDelimiter, C as EntityFormBinding, Cn as NavigationStateContext, Cr as LABEL_ICON_SIZE, Ct as EntityCardBinding, D as getDefaultFieldConfig, Dn as SelectableTableContext, Dr as getBracketNotation, Dt as useCollectionEditorDialogsState, E as DEFAULT_FIELD_CONFIGS, En as SideDialogsControllerContext, Er as PropertyKeyHint, Et as ConfigControllerProvider, F as SelectFieldBinding, Fn as UserPreview, Fr as isRelationProperty, Ft as ImportSaveInProgress, G as useSelectionDialog, Gn as ArrayOfStorageComponentsPreview, Gt as SearchIconsView, H as DateTimeFieldBinding, Hn as ArrayOfStringsPreview, Ht as parseCsvToObjects, I as RepeatFieldBinding, In as NumberPropertyPreview, It as IMPORT_BATCH_SIZE, J as useBuildUrlController, Jn as InlineEntityListPreview, Jt as BreadcrumbsProvider, K as SelectionTableBinding, Kn as RelationPreview, Kt as FieldCaption, L as ReferenceFieldBinding, Ln as BooleanPreview, Lt as saveImportedEntities, M as TextFieldBinding, Mn as FieldHelperText, Mr as getPropertyInPath, Mt as processValueMapping, N as SwitchFieldBinding, Nn as ArrayOfMapsPreview, Nr as getResolvedPropertyInPath, Nt as getInferenceType, O as getDefaultFieldId, On as ArrayCustomShapedFieldBinding, Or as getDefaultPropertiesOrder, Ot as ImportNewPropertyFieldPreview, P as StorageUploadFieldBinding, Pn as PropertyPreview, Pr as isReferenceProperty, Pt as useImportConfig, Q as useResolvedCollections, Qn as useSidePanel, Qt as addInitialSlash, R as MultiSelectFieldBinding, Rn as DatePreview, Rt as ImportFileUpload, S as isSchemaChangeCancelled, Sn as useUrlController, Sr as FieldBlock, St as CollectionCardViewBinding, T as PropertyFieldBinding, Tn as useSideDialogsController, Tr as spanClass, Tt as useCollectionEditorController, U as BlockFieldBinding, Un as ArrayPropertyEnumPreview, Ut as ArrayContainer, V as KeyValueFieldBinding, Vn as ArrayOneOfPreview, Vt as parseCsvRows, W as ArrayOfReferencesFieldBinding, Wn as ArrayEnumPreview, Wt as PropertyConfigBadge, X as useTopLevelNavigation, Xn as EntityPreviewBinding, Xt as resolveEntityView, Y as useBuildNavigationStateController, Yn as ReferencePreview, Yt as resolveEntityAction, Z as useResolvedViews, Zn as SidePanelControllerContext, Zt as mergeEntityActions, _ as useCollectionsConfigController, _n as CollectionTableBinding, _r as ImagePreview, _t as editEntityAction, a as namespaceToPropertiesPath, an as resolveCollectionPathIds, ar as getEntityTitlePropertyKeyForEntity, at as getEntityViewWidth, b as asUnavailable, bn as useAdminContext, br as FormRail, bt as DetailViewBinding, c as buildCollectionGenerationCallback, cn as SelectionMenu, cr as EnumValuesChip, d as fromSerializableCollectionConfigs, dn as resolveSelection, dr as SkeletonPropertyComponent, dt as getInitialEntityValues, en as getCollectionPathsCombinations, er as useCollectionRegistryController, et as useBuildCollectionRegistryController, f as fromSerializableProperties, fn as selectionQueryToFindParams, fr as renderSkeletonCaptionText, ft as removeEmptyContainers, g as toSerializableProperty, gn as VirtualTableInput, gr as UrlComponentPreview, gt as deleteEntityAction, h as toSerializableProperties, hn as useSelectionController, hr as renderSkeletonText, ht as copyEntityAction, i as namespaceToPropertiesOrderPath, in as removeTrailingSlash, ir as getEntityTitlePropertyKey, it as buildSidePanelsFromUrl, j as VectorFieldBinding, jn as LabelWithIcon, jr as getPropertiesWithPropertiesOrder, jt as flattenEntry, k as getFieldConfig, kn as useClearRestoreValue, kr as getIconForProperty, kt as DataNewPropertiesMapping, l as validateCollectionJson, ln as MAX_SELECTION_ROWS, lr as StorageThumbnail, lt as extractTouchedValues, m as toSerializableCollectionConfig, mr as renderSkeletonImageThumbnail, mt as CollectionViewBinding, n as getFullIdPath, nn as removeInitialAndTrailingSlashes, nr as useResolvedUser, nt as resolveNavigationFrom, o as CollectionGenerationApiError, on as resolveOpenEntityMode, or as ArrayPropertyPreview, ot as useBuildSidePanel, p as fromSerializableProperty, pn as serializeSelectionQuery, pr as renderSkeletonIcon, pt as zodToFormErrors, q as SideDialogs, qn as ArrayOfReferencesPreview, qt as useBreadcrumbsController, r as idToPropertiesPath, rn as removeInitialSlash, rr as getEntityPreviewKeys, rt as useResolvedNavigationFrom, s as DEFAULT_COLLECTION_GENERATION_ENDPOINT, sn as resolveViewMode, sr as StringPropertyPreview, st as EditViewBinding, t as getFullId, tn as getLastSegment, tr as getUserLabel, tt as useHistory, u as fromSerializableCollectionConfig, un as SELECTION_PAGE_SIZE, ur as StorageThumbnailInternal, ut as getChanges, v as LiveSchemaError, vn as SelectableTable, vr as EmptyValue, vt as resetPasswordAction, w as EntityForm, wn as useNavigationStateController, wr as isSelfLabellingProperty, wt as CollectionViewActions, x as createLiveSchemaClient, xn as UrlContext, xr as RecordMeta, xt as EntityViewBinding, y as SchemaChangeCancelled, yn as CollectionRowActions, yr as FormSections, yt as CreationResultDialog, z as MarkdownEditorFieldBinding, zn as KeyValuePreview, zt as convertFileToJson } from "./util-CyIcgnv2.js";
import { r as sanitizeUrl } from "./util-DB31IoJE.js";
import { i as PropertySelectEntry, n as ImportCollectionAction, r as ImportDataPreview } from "./import-Cxnmpyjl.js";
import { a as MAX_EXPORT_ROWS, c as downloadDataAsCsv, d as escapeCsvFormula, f as getEntityCSVExportableData, i as EXPORT_PAGE_SIZE, l as downloadEntitiesExport, n as ExportCollectionAction, o as fetchAllEntitiesForExport, p as getEntityJsonExportableData, r as BasicExportAction, s as downloadBlob, u as entryToCSVRow } from "./export-LvIpE7sE.js";
import React, { Suspense, useCallback, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { deepEqual } from "fast-equals";
import { Avatar, Button, Card, CenteredView, ChevronDownIcon, ChevronsLeftIcon, ChevronsRightIcon, Chip, CircularProgressCenter, Collapse, Container, Dialog, DialogActions, DialogContent, DialogTitle, ErrorBoundary, ExpandablePanel, IconButton, LogOutIcon, Markdown, Menu, MenuIcon, MenuItem, MoonIcon, PencilIcon, SearchBar, SettingsIcon, Sheet, Skeleton, StarIcon, SunIcon, SunMoonIcon, TextField, Tooltip, Typography, cls, defaultBorderMixin, iconSize, lazyChunk } from "@rebasepro/ui";
import { buildRoutedRebaseData, getReferenceFrom, resolveDataSource } from "@rebasepro/common";
import { CollectionResolverRegistrationContext, CollectionScopeProvider, CustomizationControllerContext, DEFAULT_API_PATH, ErrorView, IconForView, LanguageToggle, LoginView, NavigationBlockerProvider, NotFoundPage, RebaseDataContext, RebaseLogo, RebaseRoutes, SchemaDriftBanner, StudioBridgeRegistryProvider, UnsavedChangesDialog, UserSettingsView, buildCollapsedDefaults, getIcon, getLastSegment as getLastSegment$1, getNavigationEntriesFromPath, useAdminModeController, useAnalyticsController, useAuthController, useBridgeRegistration, useCollapsedGroups, useComponentOverride, useCustomizationController, useData, useDataSources, useLargeLayout, useModeController, useNavigationBlocker, useNavigationGroupLabel, useRebaseClient, useRebaseContext, useRebaseRegistry, useRebaseRegistryDispatch, useRestoreScroll, useSlot, useTranslation, useUserConfigurationPersistence } from "@rebasepro/app";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { prettifyIdentifier, toArray } from "@rebasepro/utils";
import { Link, NavLink, Outlet, Route, useLocation, useNavigate } from "react-router";
import { DndContext, DragOverlay, KeyboardSensor, MeasuringStrategy, MouseSensor, TouchSensor, closestCenter, closestCorners, getFirstCollision, pointerWithin, rectIntersection, useDndMonitor, useDroppable, useSensor, useSensors } from "@dnd-kit/core";
import { restrictToVerticalAxis, restrictToWindowEdges } from "@dnd-kit/modifiers";
import { SortableContext, arrayMove, defaultAnimateLayoutChanges, rectSortingStrategy, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Fuse from "fuse.js";
//#region src/routes/CustomViewRoute.tsx
function CustomViewRoute({ view }) {
	const breadcrumbs = useBreadcrumbsController();
	const urlController = useUrlController();
	const breadcrumbsRef = useRef(breadcrumbs);
	breadcrumbsRef.current = breadcrumbs;
	useEffect(() => {
		breadcrumbsRef.current.set({ breadcrumbs: [{
			title: view.name,
			url: urlController.buildAppUrlPath(view.slug)
		}] });
	}, [view.slug, urlController]);
	if (typeof view.view === "function") {
		const ViewComponent = view.view;
		return /* @__PURE__ */ jsx(ViewComponent, {});
	}
	return /* @__PURE__ */ jsx(Fragment, { children: view.view });
}
//#endregion
//#region src/routes/RebaseRoute.tsx
function RebaseRoute() {
	const location = useLocation();
	const collectionRegistry = useCollectionRegistryController();
	const urlController = useUrlController();
	const breadcrumbs = useBreadcrumbsController();
	const userConfigPersistence = useUserConfigurationPersistence();
	const ResolvedCollectionView = useComponentOverride("Collection.View", CollectionViewBinding);
	const hash = location.hash;
	const isSidePanel = hash.includes("#side");
	const isNew = hash.includes("#new") || hash.includes("#new_side");
	const isCopy = hash.includes("#copy");
	const isFullScreen = hash.includes("#full");
	const pathname = location.pathname;
	const navigationEntries = getNavigationEntriesFromPath({
		path: urlController.urlPathToDataPath(pathname),
		collections: collectionRegistry.collections ?? []
	});
	useEffect(() => {
		breadcrumbs.set({ breadcrumbs: navigationEntries.map((entry) => {
			if (entry.type === "entity") return {
				title: String(entry.entityId),
				url: urlController.buildUrlCollectionPath(entry.path)
			};
			else if (entry.type === "custom_view") return {
				title: String(entry.view.name ?? entry.view.key),
				url: urlController.buildUrlCollectionPath(entry.path)
			};
			else if (entry.type === "collection") return {
				title: entry.collection.name,
				url: urlController.buildUrlCollectionPath(entry.path),
				id: entry.path
			};
			else throw new Error("Unexpected navigation entry type");
		}) });
	}, [navigationEntries.map((entry) => entry.path).join(",")]);
	if (isNew) return /* @__PURE__ */ jsx(EntityFullScreenRoute, {
		pathname,
		navigationEntries,
		isNew: true,
		isCopy: false
	});
	if (navigationEntries.length === 1 && navigationEntries[0].type === "collection") {
		let collection;
		collection = collectionRegistry.getCollection(navigationEntries[0].id);
		if (!collection) collection = collectionRegistry.getCollection(navigationEntries[0].slug);
		if (!collection) {
			if (!collectionRegistry.initialised) return /* @__PURE__ */ jsx(CircularProgressCenter, {});
			return /* @__PURE__ */ jsx(UnresolvedCollectionView, { path: navigationEntries[0].slug });
		}
		return /* @__PURE__ */ jsx(ResolvedCollectionView, {
			...collection,
			parentCollectionSlugs: [],
			parentEntityIds: [],
			path: collection.slug,
			updateUrl: true,
			Actions: toArray(collection.Actions)
		}, `collection_view_${collection.slug}`);
	}
	if (isSidePanel) {
		if ([...navigationEntries].reverse().find((entry) => entry.type === "collection")) {
			let collection;
			const firstEntry = navigationEntries[0];
			collection = collectionRegistry.getCollection(firstEntry.id);
			if (!collection) collection = collectionRegistry.getCollection(firstEntry.slug);
			if (!collection) {
				if (!collectionRegistry.initialised) return /* @__PURE__ */ jsx(CircularProgressCenter, {});
				return /* @__PURE__ */ jsx(UnresolvedCollectionView, { path: firstEntry.slug });
			}
			return /* @__PURE__ */ jsx(ResolvedCollectionView, {
				...collection,
				parentCollectionSlugs: [],
				parentEntityIds: [],
				path: collection.slug,
				updateUrl: true,
				Actions: toArray(collection.Actions)
			}, `collection_view_${collection.slug}`);
		}
	}
	const lastEntityEntry = navigationEntries.find((entry) => entry.type === "entity");
	const firstCollectionEntry = navigationEntries[0];
	if (!isFullScreen && !isCopy && firstCollectionEntry?.type === "collection" && lastEntityEntry?.type === "entity" && (navigationEntries.length === 2 || navigationEntries.length === 3)) {
		let collection;
		collection = collectionRegistry.getCollection(firstCollectionEntry.id);
		if (!collection) collection = collectionRegistry.getCollection(firstCollectionEntry.slug);
		const effectiveOpenMode = collection ? resolveOpenEntityMode({
			collection,
			viewMode: resolveViewMode({
				collection,
				search: location.search,
				savedViewMode: userConfigPersistence?.getCollectionConfig(collection.slug)?.defaultViewMode
			})
		}) : void 0;
		if (collection && effectiveOpenMode === "split") {
			let selectedTab;
			if (navigationEntries.length === 3) {
				const thirdEntry = navigationEntries[2];
				if (thirdEntry.type === "collection") selectedTab = thirdEntry.collection.slug;
				else if (thirdEntry.type === "custom_view") selectedTab = thirdEntry.view.key;
			}
			if (!selectedTab && navigationEntries.length === 2 && lastEntityEntry) {
				const entityIdStr = String(lastEntityEntry.entityId);
				const entityIdIdx = pathname.lastIndexOf(`/${entityIdStr}`);
				if (entityIdIdx >= 0) {
					const afterEntity = pathname.substring(entityIdIdx + 1 + entityIdStr.length);
					const trailingSegment = afterEntity.startsWith("/") ? afterEntity.substring(1) : afterEntity;
					if (trailingSegment.length > 0) selectedTab = trailingSegment;
				}
			}
			return /* @__PURE__ */ jsx(ResolvedCollectionView, {
				...collection,
				parentCollectionSlugs: [],
				parentEntityIds: [],
				path: collection.slug,
				updateUrl: true,
				selectedEntityId: lastEntityEntry.entityId,
				selectedTab,
				Actions: toArray(collection.Actions)
			}, `collection_view_${collection.slug}`);
		}
	}
	return /* @__PURE__ */ jsx(EntityFullScreenRoute, {
		pathname,
		navigationEntries,
		isNew,
		isCopy
	});
}
function getSelectedTabFromUrl(isNew, lastCustomView) {
	if (isNew) return;
	else if (lastCustomView) {
		if (lastCustomView.type === "custom_view") return lastCustomView.view.key;
		else if (lastCustomView.type === "collection") return lastCustomView.id ?? lastCustomView.slug;
	}
}
function EntityFullScreenRoute({ pathname, navigationEntries, isNew, isCopy }) {
	const collectionRegistry = useCollectionRegistryController();
	const urlController = useUrlController();
	const navigate = useNavigate();
	const location = useLocation();
	const userConfigPersistence = useUserConfigurationPersistence();
	const defaultValues = location.state?.defaultValues;
	const hash = location.hash;
	const navigationPath = urlController.urlPathToDataPath(pathname);
	const blocked = useRef(false);
	const lastEntityEntry = [...navigationEntries].reverse().find((entry) => entry.type === "entity");
	const lastCustomView = [...lastEntityEntry ? navigationEntries.slice(navigationEntries.indexOf(lastEntityEntry) + 1) : []].reverse().find((entry) => entry.type === "custom_view" || entry.type === "collection");
	const entityId = lastEntityEntry && "entityId" in lastEntityEntry ? lastEntityEntry.entityId : void 0;
	let urlTab = getSelectedTabFromUrl(isNew, lastCustomView);
	if (!urlTab && entityId && !isNew) {
		const entityIdStr = String(entityId);
		const entityIdIdx = pathname.lastIndexOf(`/${entityIdStr}`);
		if (entityIdIdx >= 0) {
			const afterEntity = pathname.substring(entityIdIdx + 1 + entityIdStr.length);
			const trailingSegment = afterEntity.startsWith("/") ? afterEntity.substring(1) : afterEntity;
			if (trailingSegment.length > 0 && trailingSegment !== "edit") urlTab = trailingSegment;
		}
	}
	const [selectedTab, setSelectedTab] = useState(urlTab);
	const parentCollectionSlugs = collectionRegistry.getParentCollectionSlugs(navigationPath);
	const parentEntityIds = collectionRegistry.getParentEntityIds(navigationPath);
	useEffect(() => {
		if (urlTab !== selectedTab) setSelectedTab(urlTab);
	}, [urlTab]);
	const basePath = !entityId || isNew ? pathname : pathname.substring(0, pathname.lastIndexOf(`/${entityId}`));
	const entityPath = basePath + `/${entityId}`;
	const blocker = useNavigationBlocker(useCallback(({ currentLocation, nextLocation }) => {
		if (nextLocation.pathname.startsWith(entityPath)) return false;
		const nextHash = nextLocation.hash;
		if (nextHash === "#side" || nextHash === "#new_side") return false;
		const currentHash = currentLocation.hash;
		if ((currentHash === "#side" || currentHash === "#new_side") && (nextLocation.pathname === basePath || nextLocation.pathname.startsWith(entityPath))) return false;
		return blocked.current;
	}, [entityPath, basePath]));
	const lastCollectionEntry = [...navigationEntries].reverse().find((entry) => entry.type === "collection");
	if (isNew && !lastCollectionEntry) {
		if (!collectionRegistry.initialised) return /* @__PURE__ */ jsx(CircularProgressCenter, {});
		throw new Error("INTERNAL: No collection found in the navigation");
	}
	if (!isNew && !lastEntityEntry) {
		if (!collectionRegistry.initialised) return /* @__PURE__ */ jsx(CircularProgressCenter, {});
		return /* @__PURE__ */ jsx(NotFoundPage, {});
	}
	const rawCollection = isNew ? lastCollectionEntry && "collection" in lastCollectionEntry ? lastCollectionEntry.collection : void 0 : lastEntityEntry && "parentCollection" in lastEntityEntry ? lastEntityEntry.parentCollection : void 0;
	const collection = collectionRegistry.getCollection(rawCollection.slug) || rawCollection;
	const fullIdPath = isNew ? lastCollectionEntry.slug : lastEntityEntry.slug;
	const collectionPath = urlController.resolveDatabasePathsFrom(fullIdPath);
	const isEditRoute = pathname.endsWith("/edit") || pathname.split("/").pop() === "edit";
	const isDetailMode = collection.defaultEntityAction === "view" && !isNew && !isCopy && entityId && !isEditRoute;
	const showList = !isNew && !isCopy && entityId !== void 0 && navigationEntries[0]?.type === "collection" && (navigationEntries.length === 2 || navigationEntries.length === 3) && resolveOpenEntityMode({
		collection,
		viewMode: resolveViewMode({
			collection,
			search: location.search,
			savedViewMode: userConfigPersistence?.getCollectionConfig(collection.slug)?.defaultViewMode
		})
	}) === "split" ? () => navigate({
		pathname,
		search: location.search,
		hash: ""
	}) : void 0;
	if (isDetailMode) return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(DetailViewBinding, {
		entityId,
		collection,
		layout: "full_screen",
		path: collectionPath,
		selectedTab: selectedTab ?? void 0,
		onShowList: showList,
		onEditClick: () => {
			const editUrl = urlController.buildUrlCollectionPath(`${collectionPath}/${entityId}`) + "/edit";
			navigate(editUrl + hash);
		},
		onTabChange: (params) => {
			setSelectedTab(params.selectedTab);
			const newSelectedTab = params.selectedTab;
			if (newSelectedTab) navigate(`${basePath}/${entityId}/${newSelectedTab}${hash}`, { replace: true });
			else navigate(`${basePath}/${entityId}${hash}`, { replace: true });
		},
		parentCollectionSlugs,
		parentEntityIds
	}, collection.slug + "_view_" + entityId) });
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(EditViewBinding, {
		entityId: isNew ? void 0 : entityId,
		collection,
		layout: "full_screen",
		path: collectionPath,
		copy: isCopy,
		selectedTab: selectedTab ?? void 0,
		onShowList: showList,
		defaultValues: isNew ? defaultValues : void 0,
		onValuesModified: (modified) => blocked.current = modified,
		navigateBack: () => {
			const detailUrl = urlController.buildUrlCollectionPath(`${collectionPath}/${entityId}`);
			navigate(detailUrl + hash);
		},
		onSaved: (params) => {
			const newSelectedTab = params.selectedTab;
			const newEntityId = params.entityId;
			const savedHash = isNew ? "" : hash;
			if (newSelectedTab) navigate(`${basePath}/${newEntityId}/${newSelectedTab}${savedHash}`, { replace: true });
			else navigate(`${basePath}/${newEntityId}${savedHash}`, { replace: true });
		},
		onTabChange: (params) => {
			setSelectedTab(params.selectedTab);
			if (isNew) return;
			const newSelectedTab = params.selectedTab;
			if (newSelectedTab) navigate(`${basePath}/${entityId}/${newSelectedTab}${hash}`, { replace: true });
			else navigate(`${basePath}/${entityId}${hash}`, { replace: true });
		},
		parentCollectionSlugs,
		parentEntityIds
	}, collection.slug + "_" + (isNew ? "new" : isCopy ? entityId + "_copy" : entityId)), /* @__PURE__ */ jsx(UnsavedChangesDialog, {
		open: blocker?.state === "blocked",
		handleOk: () => blocker?.proceed?.(),
		handleCancel: () => blocker?.reset?.(),
		body: "You have unsaved changes in this entity."
	})] });
}
/**
* Shown when a URL names a collection the registry cannot resolve.
*
* This used to be `return null`, which renders an empty pane inside the app
* chrome: the sidebar, the nav highlight and the breadcrumb all still work,
* because those read the collections array directly, while the view itself is
* blank. Nothing is thrown, and the only trace is a `console.debug` — so the
* panel looks like it lost its data rather than like it failed to find the
* collection, and there is no string to search for.
*
* A slug containing slashes went unresolvable this way and cost an afternoon to
* find. The lookup is fixed; this is the part that made it expensive.
*/
function UnresolvedCollectionView({ path }) {
	useEffect(() => {
		console.warn(`[rebase] No collection is registered for "${path}", so this route has nothing to render. Check that the collection is in the collections array and that its slug matches the URL.`);
	}, [path]);
	return /* @__PURE__ */ jsx(CenteredView, { children: /* @__PURE__ */ jsx(ErrorView, {
		title: "Collection not found",
		error: `Nothing is registered for "${path}".`,
		tooltip: "The URL names a collection the panel does not know about. It may have been renamed or removed from the collections array, or the slug may not match the path."
	}) });
}
//#endregion
//#region src/components/ReferenceWidget.tsx
/**
* This field allows selecting reference/s.
*/
function ReferenceWidget({ name, multiselect = false, path, disabled, value, onReferenceSelected, onMultipleReferenceSelected, previewProperties, fixedFilter, size, className, includeId, includeEntityLink }) {
	const collectionRegistryController = useCollectionRegistryController();
	const collection = useMemo(() => {
		return collectionRegistryController.getCollection(path);
	}, [path, collectionRegistryController.getCollection]);
	const onSingleEntitySelected = useCallback((entity) => {
		if (disabled) return;
		if (onReferenceSelected) {
			const reference = entity ? getReferenceFrom(entity) : null;
			onReferenceSelected?.({
				reference,
				entity
			});
		}
	}, [disabled, onReferenceSelected]);
	const onMultipleEntitiesSelected = useCallback((entities) => {
		if (disabled) return;
		if (onMultipleReferenceSelected) onMultipleReferenceSelected({
			references: entities ? entities.map((e) => getReferenceFrom(e)) : null,
			entities
		});
	}, [disabled, onReferenceSelected]);
	const referenceDialogController = useSelectionDialog({
		multiselect,
		path,
		collection,
		onSingleEntitySelected,
		onMultipleEntitiesSelected,
		fixedFilter
	});
	useCallback((e) => {
		e.stopPropagation();
		if (multiselect) onMultipleEntitiesSelected([]);
		else onSingleEntitySelected(null);
	}, [onReferenceSelected]);
	let child;
	const onEntryClick = () => {
		if (disabled) return;
		referenceDialogController.open();
	};
	if (Array.isArray(value)) child = /* @__PURE__ */ jsx("div", {
		className: "flex flex-col gap-4",
		children: value.map((ref, index) => {
			return /* @__PURE__ */ jsx(ReferencePreview, {
				onClick: onEntryClick,
				reference: ref,
				disabled,
				previewProperties,
				size,
				includeId,
				includeEntityLink
			}, `reference_preview_${index}`);
		})
	});
	else if (value?.isEntityReference && value?.isEntityReference()) child = /* @__PURE__ */ jsx(ReferencePreview, {
		reference: value,
		onClick: onEntryClick,
		disabled,
		previewProperties,
		size,
		includeId,
		includeEntityLink
	});
	return /* @__PURE__ */ jsxs("div", {
		className: cls("text-sm font-medium", "min-w-80 flex flex-col gap-4", "relative transition-colors duration-200 ease-in rounded-xs font-medium", disabled ? "bg-opacity-50" : "hover:bg-opacity-75", "dark:text-white/50 text-text-primary/50 dark:text-text-primary-dark/50 dark:text-white/50", className),
		children: [child, !value && /* @__PURE__ */ jsx("div", {
			className: "justify-center text-left",
			children: /* @__PURE__ */ jsxs(Button, {
				disabled,
				onClick: onEntryClick,
				children: ["Edit ", name]
			})
		})]
	});
}
//#endregion
//#region src/hooks/useBuildSideDialogsController.tsx
function useBuildSideDialogsController() {
	const location = useLocation();
	const navigate = useNavigate();
	const locationRef = useRef(location);
	locationRef.current = location;
	const [sidePanels, setSidePanels] = useState([]);
	const sidePanelsRef = useRef(sidePanels);
	const routesStore = useRef({});
	const routesCount = useRef(0);
	const updateSidePanels = useCallback((newPanels) => {
		sidePanelsRef.current = newPanels;
		setSidePanels(newPanels);
	}, []);
	useEffect(() => {
		const newPanels = (location.state?.panels ?? []).map((key) => routesStore.current[key]).filter((p) => Boolean(p));
		if (!deepEqual(sidePanelsRef.current.map((p) => p.key), newPanels.map((p) => p.key))) {
			updateSidePanels(newPanels);
			if (newPanels.length === 0) routesCount.current = 0;
		}
	}, [location]);
	const close = useCallback(() => {
		const currentPanels = sidePanelsRef.current;
		if (currentPanels.length === 0) return;
		const lastSidePanel = currentPanels[currentPanels.length - 1];
		const updatedPanels = [...currentPanels.slice(0, -1)];
		updateSidePanels(updatedPanels);
		if (routesCount.current > 0) {
			if (lastSidePanel.urlPath) navigate(-1);
			routesCount.current--;
		} else if (lastSidePanel.parentUrlPath) {
			const baseLocation = locationRef.current.state?.base_location ?? locationRef.current;
			navigate(lastSidePanel.parentUrlPath, {
				replace: true,
				state: {
					base_location: baseLocation,
					panels: updatedPanels.map((p) => p.key)
				}
			});
		}
	}, [navigate]);
	const open = useCallback((panelProps) => {
		const newPanels = Array.isArray(panelProps) ? panelProps : [panelProps];
		newPanels.forEach((panel) => {
			routesStore.current[panel.key] = panel;
		});
		routesCount.current = routesCount.current + newPanels.length;
		const baseLocation = locationRef.current.state?.base_location ?? locationRef.current;
		const updatedPanels = [...sidePanelsRef.current, ...newPanels];
		updateSidePanels(updatedPanels);
		newPanels.forEach((panel) => {
			if (panel.urlPath) navigate(panel.urlPath, { state: {
				base_location: baseLocation,
				panels: updatedPanels.map((p) => p.key)
			} });
		});
	}, [navigate]);
	const replace = useCallback((panelProps) => {
		const newPanels = Array.isArray(panelProps) ? panelProps : [panelProps];
		newPanels.forEach((panel) => {
			routesStore.current[panel.key] = panel;
		});
		const baseLocation = locationRef.current.state?.base_location ?? locationRef.current;
		const updatedPanels = [...sidePanelsRef.current.slice(0, -newPanels.length), ...newPanels];
		updateSidePanels(updatedPanels);
		newPanels.forEach((panel) => {
			if (panel.urlPath) navigate(panel.urlPath, {
				replace: true,
				state: {
					base_location: baseLocation,
					panels: updatedPanels.map((p) => p.key)
				}
			});
		});
	}, [navigate]);
	return useMemo(() => ({
		sidePanels,
		setSidePanels: updateSidePanels,
		close,
		open,
		replace
	}), [
		sidePanels,
		updateSidePanels,
		close,
		open,
		replace
	]);
}
//#endregion
//#region src/components/SidePanelProvider.tsx
/**
* Provider that builds the SidePanelController and makes it available
* via the SidePanelControllerContext from @rebasepro/app.
*
* After the admin extraction refactor, `useBuildSidePanel` lives
* in the admin package while the context it feeds into lives in core.
* This provider bridges the two: place it inside the `<Rebase>` tree and
* above any component that calls `useSidePanel()`.
*
* Also auto-registers the side entity controller and breadcrumbs into the
* self-assembling Studio bridge (when a StudioBridgeRegistryProvider is
* mounted above in the tree).
*
* @example
* ```tsx
* <Rebase ...>
*   {({ loading }) => (
*     <SidePanelProvider>
*       <RebaseRoutes>
*         ...
*       </RebaseRoutes>
*     </SidePanelProvider>
*   )}
* </Rebase>
* ```
*
* @group Components
*/
function SidePanelProvider({ children }) {
	const collectionRegistryController = useCollectionRegistryController();
	const urlController = useUrlController();
	const navigationStateController = useNavigationStateController();
	const sideDialogsController = useBuildSideDialogsController();
	const sidePanelController = useBuildSidePanel(collectionRegistryController, urlController, navigationStateController, sideDialogsController, useAuthController());
	return /* @__PURE__ */ jsx(NavigationBlockerProvider, { children: /* @__PURE__ */ jsx(BreadcrumbsProvider, { children: /* @__PURE__ */ jsx(SideDialogsControllerContext.Provider, {
		value: sideDialogsController,
		children: /* @__PURE__ */ jsxs(SidePanelControllerContext.Provider, {
			value: sidePanelController,
			children: [/* @__PURE__ */ jsx(BridgeAutoRegistrar$1, { sidePanelController }), children]
		})
	}) }) });
}
/**
* Internal component that auto-registers side entity and breadcrumbs
* into the Studio bridge. Must be a child of BreadcrumbsProvider.
*/
function BridgeAutoRegistrar$1({ sidePanelController }) {
	const breadcrumbs = useBreadcrumbsController();
	useBridgeRegistration("sidePanelController", sidePanelController);
	useBridgeRegistration("breadcrumbs", breadcrumbs);
	return null;
}
//#endregion
//#region src/components/AdminModeSyncer.tsx
/**
* A highly customizable utility component that observes react-router routes and
* actively shifts the internal Rebase `adminModeController` context to match
* the user's active window segment (e.g., Content vs Studio mode).
*
* Placing this anywhere safely inside the Rebase layout automatically triggers
* UI mode synchronization.
*/
function AdminModeSyncer({ devViews }) {
	const location = useLocation();
	const urlController = useUrlController();
	const adminModeController = useAdminModeController();
	const currentModeRef = React.useRef(adminModeController.mode);
	currentModeRef.current = adminModeController.mode;
	const setModeRef = React.useRef(adminModeController.setMode);
	setModeRef.current = adminModeController.setMode;
	useEffect(() => {
		const path = location.pathname;
		const isContentRoute = urlController.isUrlCollectionPath(path) || path === urlController.basePath;
		const studioHomePath = urlController.basePath === "/" ? "/s" : `${urlController.basePath}/s`;
		if ((path === studioHomePath || path.startsWith(studioHomePath + "/") || devViews?.some((view) => {
			const viewPath = urlController.buildAppUrlPath(view.slug);
			return path.startsWith(`${viewPath}/`) || path === viewPath;
		})) && currentModeRef.current !== "studio") setModeRef.current("studio");
		else if (isContentRoute && currentModeRef.current !== "cms") setModeRef.current("cms");
	}, [
		location.pathname,
		urlController,
		devViews
	]);
	return null;
}
//#endregion
//#region src/components/app/useApp.tsx
var AppContext = React.createContext({
	hasDrawer: false,
	drawerHovered: false,
	drawerOpen: false,
	openDrawer: () => {
		throw new Error("openDrawer not implemented");
	},
	closeDrawer: () => {
		throw new Error("closeDrawer not implemented");
	},
	closeHover: () => {
		throw new Error("closeHover not implemented");
	},
	autoOpenDrawer: false
});
function useApp() {
	return React.useContext(AppContext);
}
//#endregion
//#region src/components/DefaultAppBar.tsx
/**
* This component renders the main app bar of Rebase.
* You will likely not need to use this component directly.
*

*/
var DefaultAppBar = function DefaultAppBar({ title, endAdornment, startAdornment, dropDownActions, includeModeToggle = true, includeLanguageToggle = true, includeUserMenu = true, className, style, user: userProp, logo: logoProp }) {
	const { hasDrawer, drawerOpen, logo: appLogo } = useApp();
	const logo = logoProp ?? appLogo;
	const navigation = useUrlController();
	const breadcrumbs = useBreadcrumbsController();
	const authController = useAuthController();
	useAdminModeController();
	const { mode, setMode } = useModeController();
	const navigate = useNavigate();
	const largeLayout = useLargeLayout();
	const user = userProp ?? authController.user;
	const { t } = useTranslation();
	const rebaseContext = useRebaseContext();
	const slotProps = React.useMemo(() => ({ context: rebaseContext }), [rebaseContext]);
	const globalSearch = useSlot("global.search", slotProps);
	const shellToolbar = useSlot("shell.toolbar", slotProps);
	let avatarComponent;
	if (user) {
		const initial = user?.displayName ? user.displayName[0].toUpperCase() : user?.email ? user.email[0].toUpperCase() : "A";
		avatarComponent = /* @__PURE__ */ jsx(Avatar, {
			src: user.photoURL ?? void 0,
			children: initial
		});
	} else if (user === void 0 || authController.initialLoading) avatarComponent = /* @__PURE__ */ jsx("div", {
		className: "p-1 flex justify-center",
		children: /* @__PURE__ */ jsx(Skeleton, { className: "w-10 h-10 rounded-full" })
	});
	else avatarComponent = null;
	return /* @__PURE__ */ jsxs("div", {
		style,
		role: "banner",
		className: cls("w-full h-14 transition-all ease-in duration-75 absolute top-0 max-w-full overflow-x-auto no-scrollbar", "flex flex-row gap-2 px-4 items-center", "backdrop-blur-sm bg-surface-frame/90", {
			"pl-[19rem]": drawerOpen && largeLayout,
			"pl-24": hasDrawer && !(drawerOpen && largeLayout),
			"z-10": largeLayout,
			"duration-100": drawerOpen && largeLayout
		}, className),
		children: [
			navigation && (!hasDrawer || title) && /* @__PURE__ */ jsx("div", {
				className: "mr-2 hidden lg:block",
				children: /* @__PURE__ */ jsx(Link, {
					className: "visited:text-inherit dark:visited:text-inherit block",
					to: navigation?.basePath ?? "/",
					children: /* @__PURE__ */ jsxs("div", {
						className: "flex flex-row gap-4",
						children: [!hasDrawer && (logo ? /* @__PURE__ */ jsx("img", {
							src: logo,
							alt: "Logo",
							className: cls("w-[32px] h-[32px] object-contain")
						}) : /* @__PURE__ */ jsx(RebaseLogo, {
							width: "32px",
							height: "32px"
						})), typeof title === "string" ? /* @__PURE__ */ jsx(Typography, {
							variant: "subtitle1",
							noWrap: true,
							children: title
						}) : title]
					})
				})
			}),
			/* @__PURE__ */ jsx("div", {
				className: "mr-8 hidden lg:block",
				children: /* @__PURE__ */ jsx("nav", {
					"aria-label": "Breadcrumb",
					children: /* @__PURE__ */ jsx("div", {
						className: "flex flex-row gap-2 items-center",
						children: breadcrumbs.breadcrumbs.map((breadcrumb, index) => {
							return /* @__PURE__ */ jsxs(React.Fragment, { children: [index > 0 && /* @__PURE__ */ jsx(Typography, {
								variant: "caption",
								color: "secondary",
								children: "/"
							}), /* @__PURE__ */ jsx(Link, {
								className: "visited:text-inherit dark:visited:text-inherit block",
								to: breadcrumb.url,
								children: /* @__PURE__ */ jsx("div", {
									className: "flex flex-row items-center gap-2 whitespace-nowrap",
									children: /* @__PURE__ */ jsx(Typography, {
										variant: "body2",
										children: breadcrumb.title
									})
								})
							}, index)] }, breadcrumb.url + "_" + index);
						})
					})
				})
			}),
			startAdornment,
			globalSearch,
			/* @__PURE__ */ jsx("div", { className: "grow" }),
			endAdornment && /* @__PURE__ */ jsx(ErrorBoundary, { children: endAdornment }),
			shellToolbar,
			includeLanguageToggle && /* @__PURE__ */ jsx(LanguageToggle, {}),
			includeModeToggle && /* @__PURE__ */ jsxs(Menu, {
				trigger: /* @__PURE__ */ jsx(IconButton, {
					color: "inherit",
					"aria-label": "Toggle theme",
					children: mode === "dark" ? /* @__PURE__ */ jsx(MoonIcon, { size: iconSize.small }) : /* @__PURE__ */ jsx(SunIcon, { size: iconSize.small })
				}),
				children: [
					/* @__PURE__ */ jsxs(MenuItem, {
						onClick: () => setMode("dark"),
						children: [
							/* @__PURE__ */ jsx(MoonIcon, { size: iconSize.smallest }),
							" ",
							t("dark_mode")
						]
					}),
					/* @__PURE__ */ jsxs(MenuItem, {
						onClick: () => setMode("light"),
						children: [
							/* @__PURE__ */ jsx(SunIcon, { size: iconSize.smallest }),
							" ",
							t("light_mode"),
							" "
						]
					}),
					/* @__PURE__ */ jsxs(MenuItem, {
						onClick: () => setMode("system"),
						children: [
							" ",
							/* @__PURE__ */ jsx(SunMoonIcon, { size: iconSize.smallest }),
							t("system_mode")
						]
					})
				]
			}),
			includeUserMenu && /* @__PURE__ */ jsxs(Menu, {
				trigger: /* @__PURE__ */ jsx("div", {
					"aria-label": "User menu",
					role: "button",
					children: avatarComponent
				}),
				children: [
					user && /* @__PURE__ */ jsxs("div", {
						className: "px-4 py-2 mb-2",
						children: [user.displayName && /* @__PURE__ */ jsx(Typography, {
							variant: "body1",
							color: "secondary",
							children: user.displayName
						}), user.email && /* @__PURE__ */ jsx(Typography, {
							variant: "body2",
							color: "secondary",
							children: user.email
						})]
					}),
					dropDownActions,
					!dropDownActions && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsxs(MenuItem, {
						onClick: () => navigate("/settings"),
						children: [/* @__PURE__ */ jsx(SettingsIcon, {}), t("account_settings")]
					}), /* @__PURE__ */ jsxs(MenuItem, {
						onClick: async () => {
							await authController.signOut();
							navigate("/");
						},
						children: [/* @__PURE__ */ jsx(LogOutIcon, {}), t("log_out")]
					})] })
				]
			})
		]
	});
};
//#endregion
//#region src/components/app/AppBar.tsx
/**
* This component renders the main app bar of Rebase.
*/
function AppBar({ children, ...props }) {
	return /* @__PURE__ */ jsx(Fragment, { children: children ?? /* @__PURE__ */ jsx(DefaultAppBar, { ...props }) });
}
AppBar.componentType = "AppBar";
//#endregion
//#region src/components/DrawerNavigationItem.tsx
function DrawerNavigationItem({ name, icon, drawerOpen, url, onClick, indented = false }) {
	const iconSlot = "w-[44px]";
	const iconWrap = indented ? /* @__PURE__ */ jsx("div", {
		className: cls("shrink-0 h-[30px]", iconSlot),
		"aria-hidden": true
	}) : /* @__PURE__ */ jsx("div", {
		className: cls("shrink-0 flex items-center justify-center h-[30px] text-surface-500 dark:text-text-secondary-dark [&>svg]:size-4 group-hover/nav:text-primary transition-colors duration-150", iconSlot),
		children: icon
	});
	const [wantsTooltip, setWantsTooltip] = React.useState(false);
	if (drawerOpen && wantsTooltip) setWantsTooltip(false);
	const listItem = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(NavLink, {
		onClick,
		"aria-label": name,
		style: {
			width: "100%",
			transition: drawerOpen ? "width 150ms ease-in" : void 0
		},
		className: ({ isActive }) => cls("rounded-lg truncate group/nav", "hover:bg-surface-hover text-surface-700 dark:text-surface-300 hover:text-surface-900 dark:hover:text-white", "flex flex-row items-center", drawerOpen ? "pr-4 h-[30px]" : "h-[30px]", "font-medium text-[13px]", isActive ? "bg-primary/8 dark:bg-primary/10 text-primary dark:text-primary [&_div]:text-primary" : ""),
		to: url,
		children: [iconWrap, /* @__PURE__ */ jsx("div", {
			className: cls("text-text-primary dark:text-surface-200", drawerOpen ? "opacity-100" : "opacity-0 hidden", "font-inherit truncate space-x-2"),
			children: name
		})]
	}) });
	return /* @__PURE__ */ jsx(Tooltip, {
		open: !drawerOpen && wantsTooltip,
		onOpenChange: setWantsTooltip,
		side: "right",
		title: name,
		children: listItem
	});
}
//#endregion
//#region src/components/DrawerNavigationGroup.tsx
/**
* Shared drawer navigation group component used by both DefaultDrawer and RebaseCloudDrawer.
* Renders a collapsible group with header and navigation items.
*/
function DrawerNavigationGroup({ group, entries, collapsed, onToggleCollapsed, drawerOpen, headerActions, onItemClick, hideHeader, icon }) {
	const groupLabel = useNavigationGroupLabel();
	const ResolvedDrawerNavigationItem = useComponentOverride("Shell.DrawerNavigationItem", DrawerNavigationItem);
	const groupIcon = !hideHeader && drawerOpen ? getIcon(icon, void 0, void 0, "small") : void 0;
	return /* @__PURE__ */ jsxs("div", {
		className: "my-2 mx-2 flex flex-col",
		children: [!hideHeader && /* @__PURE__ */ jsxs("div", {
			className: cls("pl-3 pr-2 py-0.5 flex flex-row items-center transition-colors", drawerOpen ? "cursor-pointer hover:bg-surface-hover rounded-lg" : "opacity-0 invisible pointer-events-none"),
			onClick: drawerOpen ? onToggleCollapsed : void 0,
			children: [
				/* @__PURE__ */ jsx(ChevronDownIcon, {
					size: iconSize.small,
					className: cls("text-surface-400 dark:text-surface-400 transition-transform duration-200 mr-1", collapsed ? "-rotate-90" : "rotate-0")
				}),
				groupIcon && /* @__PURE__ */ jsx("span", {
					className: "shrink-0 mr-2 flex items-center text-surface-600 dark:text-surface-300 [&>svg]:size-4",
					children: groupIcon
				}),
				/* @__PURE__ */ jsx(Typography, {
					variant: "caption",
					color: "secondary",
					className: "font-semibold text-[11px] uppercase tracking-wider flex-grow line-clamp-1 text-surface-400 dark:text-surface-400",
					children: groupLabel(group || "Views")
				}),
				headerActions && /* @__PURE__ */ jsx("div", {
					onClick: (e) => e.stopPropagation(),
					children: headerActions
				})
			]
		}), /* @__PURE__ */ jsx("div", {
			className: cls("transition-all duration-200 ease-in-out", "overflow-hidden", !hideHeader && "dark:bg-transparent", "rounded-lg", !hideHeader && collapsed ? "max-h-0 opacity-0" : "max-h-[2000px] opacity-100"),
			children: entries.map((entry) => /* @__PURE__ */ jsx(ResolvedDrawerNavigationItem, {
				icon: /* @__PURE__ */ jsx(IconForView, {
					collectionOrView: entry.collection ?? entry.view,
					size: "small"
				}),
				drawerOpen,
				onClick: () => onItemClick?.(entry),
				url: entry.url,
				name: entry.name
			}, entry.id))
		})]
	}, `drawer_group_${group}`);
}
//#endregion
//#region src/components/DefaultDrawer.tsx
/**
* Default drawer used in the admin.
*
* When no `children` are provided, renders the full admin navigation
* (collection groups, mode switch, plugin slots).
*
* When `children` **are** provided, renders the shared drawer shell
* (logo, scrollable area, footer actions, collapse toggle) with the
* custom content injected in the scrollable area. This lets consumers
* like the SaaS dashboard reuse the identical structural layout while
* supplying their own navigation items.
*
* @group Core
*/
function DefaultDrawer({ title, logo, logoDestination, children, footerActions, className, style }) {
	const { drawerHovered, drawerOpen, openDrawer, closeDrawer, logo: appLogo } = useApp();
	const resolvedLogo = logo ?? appLogo;
	const scrollRef = React.useRef(null);
	const [scrolled, setScrolled] = React.useState(false);
	const handleScroll = () => {
		if (scrollRef.current) setScrolled(scrollRef.current.scrollTop > 0);
	};
	return /* @__PURE__ */ jsxs("div", {
		role: "navigation",
		"aria-label": "Main navigation",
		className: cls("flex flex-col h-full relative grow w-full", className),
		style,
		children: [
			/* @__PURE__ */ jsx(DrawerLogo, {
				logo: resolvedLogo,
				title,
				logoDestination,
				drawerOpen,
				drawerHovered
			}),
			/* @__PURE__ */ jsx("div", {
				ref: scrollRef,
				onScroll: handleScroll,
				className: "flex-grow min-h-0 overflow-y-auto overflow-x-hidden no-scrollbar px-2",
				style: { maskImage: scrolled ? "linear-gradient(to bottom, transparent 0, black 20px, black calc(100% - 20px), transparent 100%)" : "linear-gradient(to bottom, black 0, black calc(100% - 20px), transparent 100%)" },
				children: children ?? /* @__PURE__ */ jsx(AdminNavigationContent, {})
			}),
			footerActions !== null && (footerActions !== void 0 ? footerActions : /* @__PURE__ */ jsx(DrawerFooterActions, {
				drawerOpen,
				drawerHovered
			})),
			/* @__PURE__ */ jsx(DrawerToggle, {
				drawerOpen,
				drawerHovered,
				openDrawer,
				closeDrawer
			})
		]
	});
}
/**
* Default admin navigation content — rendered inside DefaultDrawer when no
* custom `children` are provided.  Contains the mode switch, navigation
* groups, and header / footer plugin slots.
*/
function AdminNavigationContent() {
	const { drawerHovered, drawerOpen, closeDrawer, closeHover } = useApp();
	const analyticsController = useAnalyticsController();
	const navigationState = useNavigationStateController();
	const context = useRebaseContext();
	const largeLayout = useLargeLayout();
	const adminModeController = useAdminModeController();
	const registry = useRebaseRegistry();
	const ResolvedDrawerNavigationGroup = useComponentOverride("Shell.DrawerNavigationGroup", DrawerNavigationGroup);
	const allNavigationEntries = navigationState.topLevelNavigation?.navigationEntries ?? [];
	const studioViewSlugs = useMemo(() => {
		const slugs = /* @__PURE__ */ new Set();
		(registry.studioConfig?.devViews ?? []).forEach((v) => slugs.add(v.slug));
		if (registry.studioConfig && registry.cmsConfig?.collectionEditor) slugs.add("schema");
		return slugs;
	}, [registry.studioConfig, registry.cmsConfig?.collectionEditor]);
	const filteredEntries = adminModeController.mode === "studio" ? allNavigationEntries.filter((e) => e.type === "view" && studioViewSlugs.has(e.slug) || e.type === "admin") : allNavigationEntries.filter((e) => e.type !== "view" || !studioViewSlugs.has(e.slug));
	const entryGroups = new Set(filteredEntries.map((e) => e.group).filter(Boolean));
	const orderedGroups = navigationState.topLevelNavigation?.groups ?? [];
	const groupsToRender = [...orderedGroups.filter((g) => entryGroups.has(g)), ...[...entryGroups].filter((g) => !orderedGroups.includes(g))];
	const groupIcons = useMemo(() => {
		const icons = /* @__PURE__ */ new Map();
		(registry.cmsConfig?.navigationGroupMappings ?? []).forEach((mapping) => {
			if (mapping.icon) icons.set(mapping.name, mapping.icon);
		});
		return icons;
	}, [registry.cmsConfig?.navigationGroupMappings]);
	const { isGroupCollapsed, toggleGroupCollapsed } = useCollapsedGroups(groupsToRender, "drawer", useMemo(() => buildCollapsedDefaults(registry.cmsConfig?.navigationGroupMappings, "drawer"), [registry.cmsConfig?.navigationGroupMappings]));
	const headerSlot = useSlot("navigation.header", {
		drawerOpen,
		drawerHovered,
		context
	});
	const footerSlot = useSlot("navigation.footer", {
		drawerOpen,
		drawerHovered,
		context
	});
	if (!navigationState.topLevelNavigation) return null;
	const onItemClick = (view) => {
		const eventName = view.type === "collection" ? "drawer_navigate_to_collection" : view.type === "view" ? "drawer_navigate_to_view" : "unmapped_event";
		analyticsController.onAnalyticsEvent?.(eventName, { url: view.url });
		if (!largeLayout) closeDrawer();
		else if (!drawerOpen) closeHover();
	};
	const drawerVisuallyOpen = drawerOpen || drawerHovered;
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		registry.studioConfig && /* @__PURE__ */ jsx(DrawerModeSwitch, {
			drawerOpen,
			drawerHovered
		}),
		headerSlot,
		groupsToRender.map((group) => {
			const entriesInGroup = filteredEntries.filter((e) => e.group === group);
			return /* @__PURE__ */ jsx(ResolvedDrawerNavigationGroup, {
				group,
				entries: entriesInGroup,
				collapsed: isGroupCollapsed(group),
				onToggleCollapsed: () => toggleGroupCollapsed(group),
				drawerOpen: drawerVisuallyOpen,
				onItemClick,
				icon: groupIcons.get(group)
			}, `drawer_group_${group}`);
		}),
		footerSlot
	] });
}
function DrawerLogo({ logo, title, logoDestination = "/", drawerOpen, drawerHovered }) {
	const showFullContent = drawerOpen || drawerHovered;
	const { t } = useTranslation();
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-row items-center shrink-0 pt-4 pb-0 px-2",
		children: [/* @__PURE__ */ jsx(Link, {
			className: "shrink-0 flex items-center justify-center w-[56px] h-[40px]",
			to: logoDestination,
			"aria-label": t("home", { defaultValue: "Home" }),
			children: logo ? /* @__PURE__ */ jsx("img", {
				src: logo,
				alt: "Logo",
				className: "w-[28px] h-[28px] object-contain"
			}) : /* @__PURE__ */ jsx(RebaseLogo, {
				width: "28px",
				height: "28px"
			})
		}), /* @__PURE__ */ jsx("div", {
			className: cls("flex flex-row items-center overflow-hidden transition-all duration-200 ease-in-out", showFullContent ? "opacity-100 w-full ml-1" : "opacity-0 w-0 ml-0"),
			children: title && /* @__PURE__ */ jsx(Link, {
				className: "visited:text-inherit dark:visited:text-inherit block truncate",
				to: logoDestination,
				children: typeof title === "string" ? /* @__PURE__ */ jsx(Typography, {
					variant: "subtitle1",
					noWrap: true,
					className: "truncate",
					children: title
				}) : title
			})
		})]
	});
}
/**
* Toggle button at the bottom of the drawer.
* Uses double-chevron icons to indicate collapse/expand direction.
*/
function DrawerToggle({ drawerOpen, drawerHovered, openDrawer, closeDrawer }) {
	const isExpanded = drawerOpen;
	const showFullContent = isExpanded || drawerHovered && !drawerOpen;
	const [wantsTooltip, setWantsTooltip] = React.useState(false);
	if (showFullContent && wantsTooltip) setWantsTooltip(false);
	const { t } = useTranslation();
	return /* @__PURE__ */ jsx("div", {
		className: "shrink-0 mt-auto px-4 pt-0.5 pb-2",
		children: /* @__PURE__ */ jsx(Tooltip, {
			title: isExpanded ? t("collapse") : t("expand"),
			open: !showFullContent && wantsTooltip,
			onOpenChange: setWantsTooltip,
			side: "right",
			sideOffset: 12,
			asChild: true,
			children: /* @__PURE__ */ jsxs("button", {
				type: "button",
				className: cls("flex flex-row items-center rounded-lg cursor-pointer w-full", "hover:bg-surface-hover", "transition-colors duration-150", "py-2"),
				"aria-expanded": isExpanded,
				"aria-label": isExpanded ? t("collapse") : t("expand"),
				onClick: () => isExpanded ? closeDrawer() : openDrawer(),
				children: [/* @__PURE__ */ jsx("div", {
					className: "shrink-0 flex items-center justify-center w-[44px] h-[24px] text-surface-500 dark:text-surface-400",
					children: isExpanded ? /* @__PURE__ */ jsx(ChevronsLeftIcon, { size: iconSize.small }) : /* @__PURE__ */ jsx(ChevronsRightIcon, { size: iconSize.small })
				}), /* @__PURE__ */ jsx("div", {
					className: cls("overflow-hidden transition-all duration-200 ease-in-out", showFullContent ? "opacity-100 w-auto" : "opacity-0 w-0"),
					children: /* @__PURE__ */ jsx(Typography, {
						variant: "body2",
						className: "text-surface-500 dark:text-surface-400 select-none whitespace-nowrap",
						children: isExpanded ? t("collapse") : t("expand")
					})
				})]
			})
		})
	});
}
/**
* Segmented Content / Studio switch rendered inside the drawer.
* Animates in/out with the drawer open state via opacity + max-height.
*/
function DrawerModeSwitch({ drawerOpen, drawerHovered }) {
	const adminModeController = useAdminModeController();
	const urlController = useUrlController();
	const navigate = useNavigate();
	return /* @__PURE__ */ jsx("div", {
		className: cls("shrink-0 overflow-hidden transition-all duration-200 ease-in-out px-3", drawerOpen || drawerHovered ? "opacity-100 h-7 mt-2 mb-0" : "opacity-0 pointer-events-none h-7 mt-2 mb-0"),
		children: /* @__PURE__ */ jsxs("div", {
			role: "group",
			"aria-label": "Panel mode",
			className: "flex bg-surface-field rounded-lg p-0.5",
			children: [/* @__PURE__ */ jsx("button", {
				onClick: () => {
					adminModeController.setMode("cms");
					navigate(urlController.basePath ?? "/");
				},
				"aria-pressed": adminModeController.mode === "cms",
				className: cls("flex-1 px-3 py-0.5 text-xs font-medium rounded-md transition-all text-center", adminModeController.mode === "cms" ? "bg-surface-lifted shadow-sm text-text-primary dark:text-text-primary-dark" : "text-surface-500 hover:text-surface-900 dark:hover:text-white"),
				children: "CMS"
			}), /* @__PURE__ */ jsx("button", {
				onClick: () => {
					adminModeController.setMode("studio");
					navigate(urlController.basePath === "/" ? "/s" : `${urlController.basePath ?? ""}/s`);
				},
				"aria-pressed": adminModeController.mode === "studio",
				className: cls("flex-1 px-3 py-0.5 text-xs font-medium rounded-md transition-all text-center", adminModeController.mode === "studio" ? "bg-surface-lifted shadow-sm text-text-primary dark:text-text-primary-dark" : "text-surface-500 hover:text-surface-900 dark:hover:text-white"),
				children: "Studio"
			})]
		})
	});
}
/**
* Footer actions rendered at the bottom of the drawer, above the collapse/expand toggle.
* Replaces the app bar icons (language, theme, user avatar) with a drawer-native layout
* that adapts between collapsed (icons only) and expanded (full labels + user bar) states.
*
* @group Core
*/
function DrawerFooterActions({ drawerOpen, drawerHovered, dropDownActions, user: userProp }) {
	const authController = useAuthController();
	const { mode, setMode } = useModeController();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const user = userProp ?? authController.user;
	const showFullContent = drawerOpen || drawerHovered;
	const portalRef = React.useRef(null);
	let avatarComponent;
	if (user) {
		const initial = user?.displayName ? user.displayName[0].toUpperCase() : user?.email ? user.email[0].toUpperCase() : "A";
		avatarComponent = /* @__PURE__ */ jsx(Avatar, {
			src: user.photoURL ?? void 0,
			className: "w-8 h-8 text-xs",
			children: initial
		});
	} else if (user === void 0 || authController.initialLoading) avatarComponent = /* @__PURE__ */ jsx(Skeleton, { className: "w-8 h-8 rounded-full" });
	else avatarComponent = null;
	return /* @__PURE__ */ jsx("div", {
		className: "shrink-0 pt-2 pb-0",
		ref: portalRef,
		children: avatarComponent && /* @__PURE__ */ jsxs("div", {
			className: "flex items-center px-[16px] py-1",
			children: [/* @__PURE__ */ jsxs(Menu, {
				trigger: /* @__PURE__ */ jsx("div", {
					className: cls("shrink-0 flex items-center justify-center w-[44px] cursor-pointer", "rounded-md py-1", "hover:bg-surface-hover", "transition-colors duration-150"),
					role: "button",
					tabIndex: 0,
					"aria-label": t("user_menu", { defaultValue: "User menu" }),
					children: avatarComponent
				}),
				side: "top",
				align: "start",
				children: [
					user && /* @__PURE__ */ jsxs("div", {
						className: "px-4 py-2 mb-1",
						children: [user.displayName && /* @__PURE__ */ jsx(Typography, {
							variant: "body1",
							color: "secondary",
							children: user.displayName
						}), user.email && /* @__PURE__ */ jsx(Typography, {
							variant: "body2",
							color: "secondary",
							children: user.email
						})]
					}),
					dropDownActions,
					!dropDownActions && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsxs(MenuItem, {
						onClick: () => navigate("/settings"),
						children: [/* @__PURE__ */ jsx(SettingsIcon, {}), t("account_settings")]
					}), /* @__PURE__ */ jsxs(MenuItem, {
						onClick: async () => {
							await authController.signOut();
							navigate("/");
						},
						children: [/* @__PURE__ */ jsx(LogOutIcon, {}), t("log_out")]
					})] })
				]
			}), showFullContent && /* @__PURE__ */ jsxs("div", {
				className: "flex items-center gap-0",
				children: [/* @__PURE__ */ jsx(LanguageToggle, {}), /* @__PURE__ */ jsxs(Menu, {
					trigger: /* @__PURE__ */ jsx(IconButton, {
						color: "inherit",
						"aria-label": t("toggle_theme", { defaultValue: "Toggle theme" }),
						className: "text-surface-500 dark:text-surface-400",
						children: mode === "dark" ? /* @__PURE__ */ jsx(MoonIcon, { size: iconSize.small }) : mode === "light" ? /* @__PURE__ */ jsx(SunIcon, { size: iconSize.small }) : /* @__PURE__ */ jsx(SunMoonIcon, { size: iconSize.small })
					}),
					portalContainer: portalRef.current,
					side: "top",
					children: [
						/* @__PURE__ */ jsxs(MenuItem, {
							onClick: () => setMode("dark"),
							children: [
								/* @__PURE__ */ jsx(MoonIcon, { size: iconSize.smallest }),
								" ",
								t("dark_mode")
							]
						}),
						/* @__PURE__ */ jsxs(MenuItem, {
							onClick: () => setMode("light"),
							children: [
								/* @__PURE__ */ jsx(SunIcon, { size: iconSize.smallest }),
								" ",
								t("light_mode")
							]
						}),
						/* @__PURE__ */ jsxs(MenuItem, {
							onClick: () => setMode("system"),
							children: [
								/* @__PURE__ */ jsx(SunMoonIcon, { size: iconSize.smallest }),
								" ",
								t("system_mode")
							]
						})
					]
				})]
			})]
		})
	});
}
//#endregion
//#region src/components/app/Drawer.tsx
/**
* This component is in charge of rendering the drawer.
* If you add this component under your {@link Scaffold}, it will be rendered
* as a drawer, and the open and close functionality will be handled automatically.
* If you want to customise the drawer, you can create your own component and pass it as a child.
* For custom drawers, you can use the {@link useApp} to open and close the drawer.
*
*/
function Drawer({ children, title, logo, logoDestination, footerActions, className, style }) {
	return /* @__PURE__ */ jsx(Fragment, { children: children ?? /* @__PURE__ */ jsx(DefaultDrawer, {
		title,
		logo,
		logoDestination,
		footerActions,
		className,
		style
	}) });
}
Drawer.componentType = "Drawer";
/**
* Namespaced by base path: two admins served from one origin are two different
* navigations, and a single key would have them overwrite each other's drawer.
*/
function drawerOpenStorageKey(basePath) {
	return `rebase-drawer-open:${basePath || "/"}`;
}
/** `null` when the user has never toggled the drawer, or storage is unavailable. */
function readStoredDrawerOpen(key) {
	if (typeof window === "undefined") return null;
	try {
		const stored = window.localStorage.getItem(key);
		return stored === null ? null : stored === "true";
	} catch (e) {
		return null;
	}
}
function writeStoredDrawerOpen(key, open) {
	if (typeof window === "undefined") return;
	try {
		window.localStorage.setItem(key, String(open));
	} catch (e) {}
}
/**
* This view acts as a scaffold for Rebase.
*
* It is in charge of displaying the navigation drawer, top bar and main
* collection views.
* This component needs a parent {@link Rebase}
*
* @param props

* @group Core
*/
var Scaffold = React.memo(function Scaffold(props) {
	const { children, autoOpenDrawer = true, defaultDrawerOpen = false, logo, className, style, padding = true } = props;
	const slotOf = (child) => React.isValidElement(child) ? child.type?.componentType : void 0;
	const childArray = React.Children.toArray(children);
	const drawerChildren = childArray.filter((child) => slotOf(child) === "Drawer");
	if (drawerChildren.length > 1) throw Error("Only one Drawer component is allowed in Scaffold");
	const appBarChildren = childArray.filter((child) => slotOf(child) === "AppBar");
	if (appBarChildren.length > 1) throw Error("Only one AppBar component is allowed in Scaffold");
	const otherChildren = childArray.filter((child) => slotOf(child) !== "Drawer" && slotOf(child) !== "AppBar");
	const includeDrawer = drawerChildren.length > 0;
	const largeLayout = useLargeLayout();
	const storageKey = drawerOpenStorageKey(useUrlController().basePath);
	const [drawerOpen, setDrawerOpenState] = React.useState(defaultDrawerOpen && largeLayout);
	const [onHover, setOnHover] = React.useState(false);
	React.useLayoutEffect(() => {
		const stored = readStoredDrawerOpen(storageKey);
		if (stored === null) return;
		setDrawerOpenState(stored && largeLayout);
	}, [storageKey]);
	const wasLargeLayout = React.useRef(largeLayout);
	React.useEffect(() => {
		if (wasLargeLayout.current === largeLayout) return;
		wasLargeLayout.current = largeLayout;
		setDrawerOpenState(largeLayout ? readStoredDrawerOpen(storageKey) ?? defaultDrawerOpen : false);
	}, [
		largeLayout,
		defaultDrawerOpen,
		storageKey
	]);
	const setDrawerOpen = useCallback((open) => {
		setDrawerOpenState(open);
		if (!largeLayout) return;
		writeStoredDrawerOpen(storageKey, open);
	}, [largeLayout, storageKey]);
	const collapseWhenPopoverCloses = React.useRef(false);
	const setOnHoverTrue = useCallback(() => {
		if (!autoOpenDrawer) return;
		collapseWhenPopoverCloses.current = false;
		setOnHover(true);
	}, [autoOpenDrawer]);
	const setOnHoverFalse = useCallback(() => {
		if (document.querySelector("[data-radix-popper-content-wrapper]")) {
			collapseWhenPopoverCloses.current = true;
			return;
		}
		collapseWhenPopoverCloses.current = false;
		setOnHover(false);
	}, []);
	React.useEffect(() => {
		if (!onHover) return;
		const collapseIfOwed = () => {
			if (!collapseWhenPopoverCloses.current) return;
			if (document.querySelector("[data-radix-popper-content-wrapper]")) return;
			collapseWhenPopoverCloses.current = false;
			setOnHover(false);
		};
		const observer = new MutationObserver(collapseIfOwed);
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
		return () => observer.disconnect();
	}, [onHover]);
	const handleDrawerOpen = useCallback(() => {
		setDrawerOpen(true);
	}, [setDrawerOpen]);
	const handleDrawerClose = useCallback(() => {
		setDrawerOpen(false);
	}, [setDrawerOpen]);
	const computedDrawerOpen = drawerOpen;
	const computedDrawerHovered = Boolean(largeLayout && onHover);
	const hasAppBar = Boolean(appBarChildren.length > 0);
	const appContextValue = useMemo(() => ({
		hasDrawer: Boolean(includeDrawer),
		drawerOpen: computedDrawerOpen,
		drawerHovered: computedDrawerHovered,
		openDrawer: handleDrawerOpen,
		closeDrawer: handleDrawerClose,
		closeHover: setOnHoverFalse,
		logo
	}), [
		includeDrawer,
		computedDrawerOpen,
		computedDrawerHovered,
		handleDrawerOpen,
		handleDrawerClose,
		setOnHoverFalse,
		logo
	]);
	return /* @__PURE__ */ jsx(AppContext.Provider, {
		value: appContextValue,
		children: /* @__PURE__ */ jsxs("div", {
			className: cls("flex h-screen w-screen overflow-hidden", "bg-surface-frame", "text-surface-900 dark:text-white", className),
			style: {
				paddingTop: "env(safe-area-inset-top)",
				paddingLeft: "env(safe-area-inset-left)",
				paddingRight: "env(safe-area-inset-right)",
				paddingBottom: "env(safe-area-inset-bottom)",
				height: "100dvh",
				...style
			},
			children: [
				appBarChildren,
				/* @__PURE__ */ jsx(DrawerWrapper, {
					displayed: includeDrawer,
					onMouseEnter: setOnHoverTrue,
					onMouseMove: setOnHoverTrue,
					onMouseLeave: setOnHoverFalse,
					open: drawerOpen,
					hovered: onHover,
					setDrawerOpen,
					children: includeDrawer && drawerChildren
				}),
				/* @__PURE__ */ jsxs("main", {
					className: "flex flex-col grow overflow-auto",
					children: [hasAppBar && /* @__PURE__ */ jsx(DrawerHeader, {}), /* @__PURE__ */ jsx("div", {
						className: cls("bg-surface-sheet", "grow overflow-auto m-0", "lg:border lg:border-hairline", {
							"mt-1 lg:m-0 lg:mx-2 lg:mb-2 lg:rounded-xl": padding,
							"lg:mt-2": !hasAppBar && padding,
							"lg:mt-4": !hasAppBar && !padding
						}),
						children: /* @__PURE__ */ jsx(ErrorBoundary, { children: otherChildren })
					})]
				})
			]
		})
	});
}, deepEqual);
var DrawerHeader = () => {
	return /* @__PURE__ */ jsx("div", { className: "flex flex-col min-h-14" });
};
function DrawerWrapper(props) {
	const layoutWidth = !props.displayed ? 0 : props.open ? 280 : 72;
	const visualWidth = !props.displayed ? 0 : props.open || props.hovered ? 280 : 72;
	const isFloating = props.hovered && !props.open;
	const { t } = useTranslation();
	const innerDrawer = /* @__PURE__ */ jsx("div", {
		className: cls("h-full overflow-hidden bg-surface-frame", defaultBorderMixin, isFloating ? "absolute top-0 left-0 bottom-0 z-50 shadow-lg border-r" : "relative"),
		style: {
			width: visualWidth,
			transition: "left 75ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, opacity 75ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, width 75ms cubic-bezier(0.4, 0, 0.6, 1) 0ms"
		},
		children: /* @__PURE__ */ jsx("div", {
			className: "flex flex-col h-full",
			children: props.children
		})
	});
	if (!useLargeLayout()) {
		if (!props.displayed) return null;
		return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(IconButton, {
			color: "inherit",
			"aria-label": t("open_menu"),
			onClick: () => props.setDrawerOpen(true),
			className: "absolute sm:top-2 sm:left-4 top-1 left-2",
			children: /* @__PURE__ */ jsx(MenuIcon, {})
		}), /* @__PURE__ */ jsx(Sheet, {
			side: "left",
			transparent: true,
			open: props.open,
			onOpenChange: props.setDrawerOpen,
			title: t("navigation_drawer"),
			overlayClassName: "bg-surface-scrim",
			children: innerDrawer
		})] });
	}
	return /* @__PURE__ */ jsx("div", {
		className: "z-20 relative flex-shrink-0 overflow-visible",
		onMouseEnter: props.onMouseEnter,
		onMouseMove: props.onMouseMove,
		onMouseLeave: props.onMouseLeave,
		style: {
			width: layoutWidth,
			minWidth: layoutWidth,
			transition: "left 75ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, opacity 75ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, width 75ms cubic-bezier(0.4, 0, 0.6, 1) 0ms"
		},
		children: innerDrawer
	});
}
//#endregion
//#region src/components/RebaseCMS.tsx
/**
* Declarative component to configure the admin in Rebase.
* Renders nothing — purely registers config into the RebaseRegistry.
*
* When `collectionEditor` is provided, the built-in visual schema editor
* is auto-wired as a native feature (slots, provider, Studio view) without
* needing any external plugin.
*/
function RebaseCMS({ collections, views, homePage, entityViews, collectionViews, entityActions, collectionEditor, navigationGroupMappings, basePath }) {
	const dispatch = useRebaseRegistryDispatch();
	useLayoutEffect(() => {
		dispatch.registerAdmin({
			collections,
			views,
			homePage,
			entityViews,
			collectionViews,
			entityActions,
			collectionEditor,
			navigationGroupMappings,
			basePath
		});
		return () => dispatch.unregisterAdmin();
	}, [
		dispatch,
		collections,
		views,
		homePage,
		entityViews,
		collectionViews,
		entityActions,
		collectionEditor,
		navigationGroupMappings,
		basePath
	]);
	return null;
}
//#endregion
//#region src/components/RebaseAuthGate.tsx
/**
* Auth gate component that handles the authentication flow.
*
* - Shows a loading spinner while `authController.initialLoading` is true.
* - Shows the login view when no user is authenticated.
* - Renders `children` when a user is authenticated.
*
* **Independently usable**: Use this alone when you want auth gating
* without the full admin layout or navigation.
*
* @example
* ```tsx
* <RebaseAuthGate>
*   <MyCustomApp />
* </RebaseAuthGate>
* ```
*/
function RebaseAuthGate({ children }) {
	const registry = useRebaseRegistry();
	const authController = useAuthController();
	if (authController?.initialLoading) return /* @__PURE__ */ jsx(CircularProgressCenter, { size: "large" });
	if (!authController?.user) return /* @__PURE__ */ jsx(Fragment, { children: registry.authConfig?.loginView ?? /* @__PURE__ */ jsx(LoginView, { authController }) });
	return /* @__PURE__ */ jsx(Fragment, { children });
}
//#endregion
//#region src/collection_editor/useLiveSchemaEditing.tsx
/**
* The plan-then-confirm flow, as a hook.
*
* Owns three things that belong together and nothing else: whether the backend
* can edit its schema, the plan for the change somebody is making, and the
* dialog they confirm it in. The config controller calls `reviewChange` and
* awaits it; everything about *how* the confirmation happens stays here.
*
* ## Why `reviewChange` returns a promise that can reject
*
* Because the editor needs to know. A save that was cancelled must not leave
* the form thinking it succeeded — the collection on screen would then differ
* from the one on disk, and the next save would be computed from the wrong
* `before`. Rejecting with {@link SchemaChangeCancelled} is how "the person
* said no" reaches the caller as an outcome rather than as silence.
*/
/**
* Loaded when a change is actually being reviewed, not before.
*
* This hook is reached from the collections config controller, which is
* constructed on every admin boot — so a static import would put the dialog and
* the `@rebasepro/ui` surface it draws on into the **eager** bundle: everything
* a browser downloads before the login screen paints. It cost 14 kB there, for
* a dialog most sessions never open. The bundle budget caught it.
*/
var SchemaChangeDialog = lazyChunk(() => import("./SchemaChangeDialog-BeP0A4MJ.js").then((n) => n.n).then((m) => ({ default: m.SchemaChangeDialog })));
function useLiveSchemaEditing(options) {
	const { baseUrl, authKey, writeSourceOnly } = options;
	const optionsRef = useRef(options);
	optionsRef.current = options;
	const client = useMemo(() => options.client ?? createLiveSchemaClient({
		baseUrl,
		getAuthToken: () => optionsRef.current.getAuthToken?.() ?? null
	}), [baseUrl, options.client]);
	const [status, setStatus] = useState();
	const [pending, setPending] = useState();
	const [plan, setPlan] = useState();
	const [planError, setPlanError] = useState();
	const [result, setResult] = useState();
	const [applying, setApplying] = useState(false);
	const [applyError, setApplyError] = useState();
	const probe = useRef(void 0);
	/** Which review a plan response belongs to. See `reviewChange`. */
	const reviewToken = useRef(0);
	const ready = useCallback(() => {
		const key = [client, authKey];
		const current = probe.current;
		if (!current || current.key[0] !== key[0] || current.key[1] !== key[1]) probe.current = {
			key,
			promise: client.status()
		};
		return probe.current.promise;
	}, [client, authKey]);
	useEffect(() => {
		let cancelled = false;
		ready().then((answer) => {
			if (!cancelled) setStatus(answer);
		});
		return () => {
			cancelled = true;
		};
	}, [ready]);
	/**
	* Ask what the change would do, and ignore an answer that arrives late.
	*
	* Separate from `reviewChange` so it can be issued *again* without starting
	* a new review: a plan that failed on a dropped connection should cost a
	* click, not the whole wizard — the person has already filled in the form,
	* and making them do it twice for a transient failure is the kind of thing
	* that teaches people to distrust the preview.
	*/
	const requestPlan = useCallback(async (change) => {
		const token = ++reviewToken.current;
		try {
			const answer = await client.plan(change);
			if (token === reviewToken.current) setPlan(answer);
		} catch (err) {
			if (token !== reviewToken.current) return;
			setPlanError(err instanceof LiveSchemaError || err instanceof Error ? err.message : String(err));
		}
	}, [client]);
	const onRetry = useCallback(() => {
		if (!pending) return;
		setPlanError(void 0);
		setPlan(void 0);
		requestPlan(pending.change);
	}, [pending, requestPlan]);
	const clear = useCallback(() => {
		setPending(void 0);
		setPlan(void 0);
		setPlanError(void 0);
		setResult(void 0);
		setApplyError(void 0);
		setApplying(false);
	}, []);
	const reviewChange = useCallback((change) => {
		return new Promise((resolve, reject) => {
			setPending((previous) => {
				previous?.reject(new SchemaChangeCancelled());
				return {
					change,
					resolve,
					reject
				};
			});
			setPlan(void 0);
			setPlanError(void 0);
			setResult(void 0);
			setApplyError(void 0);
			setApplying(false);
			requestPlan(change);
		});
	}, [requestPlan]);
	const onConfirm = useCallback(() => {
		if (!pending) return;
		setApplying(true);
		setApplyError(void 0);
		client.apply(pending.change).then((answer) => {
			setResult(answer);
			setApplying(false);
			pending.resolve();
			setPending(void 0);
		}, (err) => {
			setApplying(false);
			setApplyError(err instanceof Error ? err.message : String(err));
		});
	}, [client, pending]);
	const onSourceOnly = useCallback(() => {
		if (!pending || !writeSourceOnly) return;
		setApplying(true);
		setApplyError(void 0);
		const settle = pending;
		writeSourceOnly(settle.change).then(() => {
			clear();
			settle.resolve();
		}, (err) => {
			setApplying(false);
			setApplyError(err instanceof Error ? err.message : String(err));
		});
	}, [
		pending,
		writeSourceOnly,
		clear
	]);
	const onClose = useCallback(() => {
		if (applying) return;
		const settle = pending;
		clear();
		if (settle && !result) settle.reject(new SchemaChangeCancelled());
	}, [
		applying,
		pending,
		result,
		clear
	]);
	const open = Boolean(pending) || Boolean(result);
	return {
		status,
		ready,
		reviewChange,
		dialog: open ? /* @__PURE__ */ jsx(Suspense, {
			fallback: null,
			children: /* @__PURE__ */ jsx(SchemaChangeDialog, {
				open,
				collectionId: pending?.change.collectionId ?? "",
				plan,
				planError,
				result,
				applying,
				applyError,
				onConfirm,
				onRetry: planError ? onRetry : void 0,
				onSourceOnly: writeSourceOnly ? onSourceOnly : void 0,
				onClose,
				applyRefusedBecause: status && !status.canApply ? status.applyRefusedBecause : void 0,
				target: status && {
					repository: status.repository,
					branch: status.branch
				}
			})
		}) : null
	};
}
//#endregion
//#region src/collection_editor/useLocalCollectionsConfigController.tsx
/**
* The guess this hook used to make on its own.
*
* `process.env.NODE_ENV` here is the *frontend bundle's* build mode. Whether
* the schema editor exists is decided by a different process entirely — the
* server's own `NODE_ENV`, its `collectionsDir`, whether its collections were
* introspected, whether `ts-morph` is installed. The two disagree in every
* ordinary setup: a dev frontend against a deployed API, a `baas` project, a
* hosted console. When they did, the editor offered itself and every save came
* back `404 Not Found`. It is kept only as the answer for a backend too old to
* be asked.
*/
var buildModeGuess = () => process.env.NODE_ENV === "production";
function useLocalCollectionsConfigController(clientOrUrl, baseCollections = [], options) {
	const parsedCollections = baseCollections;
	const optionsRef = useRef(options);
	optionsRef.current = options;
	const clientBaseUrl = typeof clientOrUrl === "string" ? clientOrUrl : clientOrUrl?.baseUrl ?? "";
	const clientApiPath = typeof clientOrUrl === "object" && clientOrUrl !== null && clientOrUrl.apiPath || DEFAULT_API_PATH;
	const editorUrl = `${String(clientBaseUrl).replace(/\/$/, "")}${clientApiPath}/schema-editor`;
	const resolveToken = async () => {
		let token = optionsRef.current?.getAuthToken ? await optionsRef.current.getAuthToken() : null;
		if (!token && typeof clientOrUrl === "object" && clientOrUrl !== null && clientOrUrl.resolveToken) token = await clientOrUrl.resolveToken();
		return token ?? null;
	};
	const request = async (endpoint, payload) => {
		try {
			const token = await resolveToken();
			const headers = { "Content-Type": "application/json" };
			if (token) headers["Authorization"] = `Bearer ${token}`;
			const response = await fetch(`${editorUrl}${endpoint}`, {
				method: "POST",
				headers,
				body: JSON.stringify(payload)
			});
			if (!response.ok) {
				const text = await response.text();
				let err = {};
				try {
					err = JSON.parse(text);
				} catch (e) {}
				if (Object.keys(err).length === 0) err = { message: text };
				console.error("dev server error payload:", err);
				const errObj = err.error;
				const errMessage = typeof errObj === "object" && errObj !== null ? errObj.message : typeof errObj === "string" ? errObj : err.message;
				throw new Error(errMessage || "Error communicating with local dev server");
			}
		} catch (e) {
			console.error("fetch request failed", e);
			throw e;
		}
	};
	const forcedReadOnly = options?.readOnly;
	const authKey = options?.authKey ?? null;
	const [availability, setAvailability] = useState({ state: "unknown" });
	useEffect(() => {
		if (forcedReadOnly === true) return;
		let cancelled = false;
		(async () => {
			try {
				const token = await resolveToken();
				const response = await fetch(`${editorUrl}/status`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
				if (cancelled) return;
				if (response.status === 404) {
					setAvailability({ state: "unknown" });
					return;
				}
				const body = await response.json().catch(() => ({}));
				if (cancelled) return;
				if (response.ok) setAvailability({
					state: "known",
					enabled: body.enabled === true,
					reason: body.reason
				});
				else setAvailability({
					state: "known",
					enabled: false,
					reason: body.error?.message ?? `The backend refused to say whether collections are editable (HTTP ${response.status}).`
				});
			} catch {
				if (!cancelled) setAvailability({ state: "unknown" });
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [
		editorUrl,
		forcedReadOnly,
		authKey
	]);
	const liveSchema = useLiveSchemaEditing({
		baseUrl: `${String(clientBaseUrl).replace(/\/$/, "")}${clientApiPath}/admin/schema`,
		getAuthToken: resolveToken,
		authKey,
		writeSourceOnly: async ({ collectionId, collection }) => {
			await request("/collection/save", {
				collectionId,
				collectionData: collection
			});
		}
	});
	/**
	* Perform a write, through the live editor when there is one.
	*
	* `sourceOnly` is the write this controller has always done. It stays the
	* whole behaviour on a backend that cannot edit its schema — a bundle
	* deployment, a non-Postgres driver, a version too old to be asked — so
	* nothing about the editor depends on the feature being there.
	*/
	const write = async (collectionId, collection, sourceOnly) => {
		if (!(await liveSchema.ready()).enabled) return sourceOnly();
		await liveSchema.reviewChange({
			collectionId,
			collection
		});
	};
	const readOnly = forcedReadOnly ?? (availability.state === "known" ? !availability.enabled : buildModeGuess());
	const readOnlyReason = availability.state === "known" && availability.reason ? availability.reason : "Collections can only be edited against a backend running the schema editor, which is off in production.";
	const findCollection = (id) => parsedCollections.find((c) => c.id === id || c.slug === id);
	/**
	* The whole collection as it should end up.
	*
	* Live editing computes the proposed state by replacing one collection in
	* the set, so it needs all of it: handed a patch, it would read every
	* property the patch does not mention as a removal and refuse the change.
	* A collection this does not recognise is a new one, and the patch is the
	* whole of it.
	*/
	const wholeCollection = (id, patch) => {
		const current = findCollection(id);
		return current ? {
			...current,
			...patch
		} : patch;
	};
	return useMemo(() => ({
		loading: false,
		readOnly,
		readOnlyReason,
		collections: parsedCollections,
		dialog: liveSchema.dialog,
		getCollection: (id) => {
			const found = findCollection(id);
			if (found) return found;
			throw Error(`Collection ${id} not found in local mode`);
		},
		saveCollection: async ({ id, collectionData }) => {
			await write(id, collectionData, () => request("/collection/save", {
				collectionId: id,
				collectionData
			}));
		},
		updateCollection: async ({ id, collectionData }) => {
			await write(id, wholeCollection(id, collectionData), () => request("/collection/save", {
				collectionId: id,
				collectionData
			}));
		},
		deleteCollection: async ({ id }) => {
			await request("/collection/delete", { collectionId: id });
		},
		saveProperty: async ({ path, propertyKey, property, newPropertiesOrder }) => {
			const properties = {
				...findCollection(path)?.properties ?? {},
				[propertyKey]: property
			};
			const proposed = wholeCollection(path, {
				properties,
				...newPropertiesOrder ? { propertiesOrder: newPropertiesOrder } : {}
			});
			await write(path, proposed, async () => {
				await request("/property/save", {
					collectionId: path,
					propertyKey,
					propertyConfig: property
				});
				if (newPropertiesOrder) await request("/collection/save", {
					collectionId: path,
					collectionData: { propertiesOrder: newPropertiesOrder },
					partial: true
				});
			});
		},
		deleteProperty: async ({ path, propertyKey, newPropertiesOrder }) => {
			await request("/property/delete", {
				collectionId: path,
				propertyKey
			});
			if (newPropertiesOrder) await request("/collection/save", {
				collectionId: path,
				collectionData: { propertiesOrder: newPropertiesOrder },
				partial: true
			});
		},
		updatePropertiesOrder: async ({ collection, fullPath, newPropertiesOrder }) => {
			const collectionId = collection.id || fullPath.split("/").pop();
			await request("/collection/save", {
				collectionId,
				collectionData: { propertiesOrder: newPropertiesOrder },
				partial: true
			});
		},
		updateKanbanColumnsOrder: async () => {},
		navigationEntries: [],
		saveNavigationEntries: async () => {}
	}), [
		clientOrUrl,
		parsedCollections,
		readOnly,
		readOnlyReason,
		options?.getAuthToken,
		liveSchema.dialog,
		liveSchema.status
	]);
}
//#endregion
//#region src/components/RebaseNavigation.tsx
var EMPTY_PLUGINS = [];
var EMPTY_COLLECTIONS = [];
var CollectionsStudioView = lazyChunk(() => import("./RouterCollectionsStudioView-EK8Knq5I.js").then((n) => n.n).then((m) => ({ default: m.RouterCollectionsStudioView })));
/**
* Navigation layer — builds and provides all admin navigation controllers:
* collection registry, URL controller, navigation state, side entity,
* and the self-assembling Studio bridge.
*
* Also handles the collection editor config controller when enabled.
*
* **Independently usable**: Use this when you need admin navigation
* (entity tables, side panels) in a custom layout.
*
* @example
* ```tsx
* <RebaseNavigation>
*   <MyCustomLayout>
*     <CollectionViewBinding ... />
*   </MyCustomLayout>
* </RebaseNavigation>
* ```
*/
function RebaseNavigation({ children }) {
	const registry = useRebaseRegistry();
	const context = useRebaseContext();
	const adminModeController = useAdminModeController();
	const userConfigPersistence = useUserConfigurationPersistence();
	const collectionEditorConfig = registry.cmsConfig?.collectionEditor;
	const collectionEditorEnabled = Boolean(collectionEditorConfig) || Boolean(registry.studioConfig);
	const collectionEditorOptions = useMemo(() => {
		if (collectionEditorConfig === true || !collectionEditorConfig) return {};
		return collectionEditorConfig;
	}, [collectionEditorConfig]);
	const cmsCollections = registry.cmsConfig?.collections ?? EMPTY_COLLECTIONS;
	const collectionsBuilder = useMemo(() => Array.isArray(cmsCollections) ? () => [...cmsCollections] : cmsCollections, [cmsCollections]);
	const dataSources = useDataSources();
	const collectionRegistryController = useBuildCollectionRegistryController({
		userConfigPersistence,
		dataSources: dataSources.registry
	});
	const defaultData = useData();
	const getCollectionRef = useRef(collectionRegistryController.getCollection);
	getCollectionRef.current = collectionRegistryController.getCollection;
	useContext(CollectionResolverRegistrationContext)(useCallback((slug) => getCollectionRef.current(slug), []));
	const routedData = useMemo(() => buildRoutedRebaseData({
		defaultData,
		sources: dataSources.sources,
		resolveKey: (slugOrPath) => resolveDataSource(getCollectionRef.current(slugOrPath), dataSources.registry).key
	}), [defaultData, dataSources]);
	const urlController = useBuildUrlController({
		basePath: useMemo(() => {
			const raw = registry.cmsConfig?.basePath;
			if (!raw || raw === "/") return "/";
			const trimmed = raw.replace(/^\/+/, "").replace(/\/+$/, "");
			return trimmed ? `/${trimmed}` : "/";
		}, [registry.cmsConfig?.basePath]),
		baseCollectionPath: "/c",
		collectionRegistryController
	});
	const rebaseClient = useRebaseClient();
	const authController = useAuthController();
	const resolvedCollections = useMemo(() => Array.isArray(cmsCollections) ? cmsCollections : [], [cmsCollections]);
	useEffect(() => {
		if (process.env.NODE_ENV === "production") return;
		const { registry, sources } = dataSources;
		const missing = Object.values(registry).filter((d) => (d.transport === "direct" || d.transport === "custom") && !sources[d.key]).map((d) => d.key);
		if (missing.length > 0) console.warn(`[Rebase] These data source(s) declare a direct/custom transport but have no client-side driver and will fall back to the default data source: ${missing.map((k) => `"${k}"`).join(", ")}. Provide a \`driver\` for them in \`dataSources\` on <Rebase>.`);
	}, [dataSources]);
	const internalConfigController = useLocalCollectionsConfigController(rebaseClient, resolvedCollections, collectionEditorEnabled ? {
		readOnly: collectionEditorOptions?.readOnly,
		getAuthToken: collectionEditorOptions?.getAuthToken ?? authController?.getAuthToken,
		authKey: authController?.user?.uid ?? null
	} : { readOnly: true });
	const schemaView = useMemo(() => {
		if (!collectionEditorEnabled) return void 0;
		const studioTools = registry.studioConfig?.tools ?? [
			"sql",
			"js",
			"rls",
			"schema",
			"storage"
		];
		if (!registry.studioConfig || !studioTools.includes("schema")) return void 0;
		return {
			slug: "schema",
			name: "Edit collections",
			group: "Database",
			icon: "LayoutList",
			nestedRoutes: true,
			view: /* @__PURE__ */ jsx(Suspense, {
				fallback: /* @__PURE__ */ jsx(CircularProgressCenter, {}),
				children: /* @__PURE__ */ jsx(CollectionsStudioViewFromContext, {})
			})
		};
	}, [collectionEditorEnabled, registry.studioConfig]);
	const devViews = useMemo(() => {
		const base = registry.studioConfig?.devViews ?? [];
		if (schemaView) return [...base, schemaView];
		return base;
	}, [registry.studioConfig?.devViews, schemaView]);
	const cmsViews = registry.cmsConfig?.views;
	const mergedViews = useMemo(() => {
		if (!cmsViews) return devViews;
		if (Array.isArray(cmsViews) && cmsViews.length === 0) return devViews;
		if (typeof cmsViews === "function") return async (params) => {
			return [...await cmsViews(params) ?? [], ...devViews];
		};
		return [...cmsViews, ...devViews];
	}, [cmsViews, devViews]);
	const parentCustomizationController = useCustomizationController();
	const navigationStateController = useBuildNavigationStateController({
		plugins: parentCustomizationController.plugins ?? EMPTY_PLUGINS,
		collections: collectionsBuilder,
		views: mergedViews,
		navigationGroupMappings: registry.cmsConfig?.navigationGroupMappings,
		authController: context.authController,
		data: routedData,
		collectionRegistryController,
		urlController,
		adminMode: adminModeController?.mode
	});
	const enrichedCustomizationController = useMemo(() => {
		const cmsEntityViews = registry.cmsConfig?.entityViews ?? [];
		const cmsEntityActions = registry.cmsConfig?.entityActions ?? [];
		const cmsCollectionViews = registry.cmsConfig?.collectionViews ?? [];
		if (cmsEntityViews.length === 0 && cmsEntityActions.length === 0 && cmsCollectionViews.length === 0) return parentCustomizationController;
		return {
			...parentCustomizationController,
			entityViews: [...parentCustomizationController.entityViews ?? [], ...cmsEntityViews.filter((v) => !(parentCustomizationController.entityViews ?? []).some((ev) => ev.key === v.key))],
			entityActions: [...parentCustomizationController.entityActions ?? [], ...cmsEntityActions.filter((a) => !(parentCustomizationController.entityActions ?? []).some((ea) => ea.key === a.key))],
			collectionViews: [...parentCustomizationController.collectionViews ?? [], ...cmsCollectionViews.filter((v) => !(parentCustomizationController.collectionViews ?? []).some((cv) => cv.key === v.key))]
		};
	}, [
		parentCustomizationController,
		registry.cmsConfig?.entityViews,
		registry.cmsConfig?.entityActions,
		registry.cmsConfig?.collectionViews
	]);
	const navigationContent = /* @__PURE__ */ jsx(RebaseDataContext.Provider, {
		value: routedData,
		children: /* @__PURE__ */ jsx(CustomizationControllerContext.Provider, {
			value: enrichedCustomizationController,
			children: /* @__PURE__ */ jsx(StudioBridgeRegistryProvider, { children: /* @__PURE__ */ jsx(CollectionRegistryContext.Provider, {
				value: collectionRegistryController,
				children: /* @__PURE__ */ jsx(UrlContext.Provider, {
					value: urlController,
					children: /* @__PURE__ */ jsx(NavigationStateContext.Provider, {
						value: navigationStateController,
						children: /* @__PURE__ */ jsxs(SidePanelProvider, { children: [/* @__PURE__ */ jsx(BridgeAutoRegistrar, {
							collectionRegistryController,
							urlController,
							navigationStateController,
							canWriteToCodebase: !internalConfigController.readOnly
						}), children] })
					})
				})
			}) })
		})
	});
	if (collectionEditorEnabled) return /* @__PURE__ */ jsx(ConfigControllerProvider, {
		collectionConfigController: internalConfigController,
		pathSuggestions: collectionEditorOptions?.pathSuggestions,
		children: navigationContent
	});
	return navigationContent;
}
/**
* The injected "Edit collections" view, bound to the live config controller.
*
* Exists so the element stored in the navigation state does not close over a
* controller instance — see the comment at its construction site.
*/
function CollectionsStudioViewFromContext() {
	return /* @__PURE__ */ jsx(CollectionsStudioView, { configController: useCollectionsConfigController() });
}
/**
* Internal component that auto-registers admin controllers into the
* self-assembling Studio bridge. Must be rendered inside both the
* navigation contexts and the StudioBridgeRegistryProvider.
*/
function BridgeAutoRegistrar({ collectionRegistryController, urlController, navigationStateController, canWriteToCodebase }) {
	useBridgeRegistration("collectionRegistry", collectionRegistryController);
	useBridgeRegistration("urlController", urlController);
	useBridgeRegistration("navigationState", navigationStateController);
	useBridgeRegistration("capabilities", useMemo(() => ({ codebase: canWriteToCodebase }), [canWriteToCodebase]));
	return null;
}
//#endregion
//#region src/components/RebaseLayout.tsx
/**
* Layout layer — provides the Scaffold, Drawer, and SideDialogs.
*
* Wraps the route outlet with the standard Rebase admin layout.
* Override the drawer via props; pass `appBar` to add a top bar (there is
* none by default — the drawer owns navigation and user actions).
*
* **Independently usable**: Use this when you want the Rebase layout
* without its default route definitions.
*
* It takes no children: the routed view arrives through react-router's
* `<Outlet/>`. This example used to pass `<Route>` elements, which is neither
* what the component renders nor something `RebaseLayoutProps` accepts — a
* reader following it wrote a type error whose message was about `children`,
* not about routes.
*
* Hand it to `<RebaseRouteDefs layout>`, which renders the routes inside it:
*
* @example
* ```tsx
* <RebaseRouteDefs layout={<RebaseLayout title="My Admin" appBar={<AppBar/>}/>}>
*     <Route path="/custom" element={<CustomView/>}/>
* </RebaseRouteDefs>
* ```
*/
function RebaseLayout(props) {
	const { title = "Rebase", appBar, drawer, autoOpenDrawer = true, defaultDrawerOpen = false, logo, devViews = [] } = props;
	const adminModeController = useAdminModeController();
	const ResolvedDrawer = useComponentOverride("Shell.Drawer", Drawer);
	const ActiveDrawer = drawer ?? /* @__PURE__ */ jsx(ResolvedDrawer, {
		title,
		logoDestination: adminModeController.mode === "studio" ? "/s" : "/"
	});
	return /* @__PURE__ */ jsxs(Scaffold, {
		autoOpenDrawer,
		defaultDrawerOpen,
		logo,
		children: [
			/* @__PURE__ */ jsx(AdminModeSyncer, { devViews }),
			appBar,
			ActiveDrawer,
			/* @__PURE__ */ jsx(Outlet, {}),
			/* @__PURE__ */ jsx(SideDialogs, {})
		]
	});
}
//#endregion
//#region src/components/HomePage/FavouritesView.tsx
function NavigationChip({ entry }) {
	const navigate = useNavigate();
	const userConfigurationPersistence = useUserConfigurationPersistence();
	if (!userConfigurationPersistence) return null;
	const favourite = userConfigurationPersistence.favouritePaths.includes(entry.slug);
	const onIconClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (favourite) userConfigurationPersistence.setFavouritePaths(userConfigurationPersistence.favouritePaths.filter((p) => p !== entry.slug));
		else userConfigurationPersistence.setFavouritePaths([...userConfigurationPersistence.favouritePaths, entry.slug]);
	};
	return /* @__PURE__ */ jsx(Chip, {
		onClick: () => navigate(entry.url),
		icon: /* @__PURE__ */ jsx(StarIcon, {
			onClick: onIconClick,
			size: iconSize.small,
			className: favourite ? "text-secondary" : "text-surface-400 dark:text-surface-500"
		}),
		children: entry.name
	}, entry.slug);
}
function FavouritesView({ hidden }) {
	const navigationStateController = useNavigationStateController();
	const userConfigurationPersistence = useUserConfigurationPersistence();
	if (!userConfigurationPersistence) return null;
	const favouriteCollections = (userConfigurationPersistence?.favouritePaths ?? []).map((path) => navigationStateController.topLevelNavigation?.navigationEntries.find((entry) => entry.slug === path)).filter(Boolean);
	return /* @__PURE__ */ jsx(Collapse, {
		in: favouriteCollections.length > 0,
		children: /* @__PURE__ */ jsx("div", {
			className: "flex flex-row flex-wrap gap-2 pb-2 min-h-[32px]",
			children: favouriteCollections.map((entry) => /* @__PURE__ */ jsx(NavigationChip, { entry }, entry.slug))
		})
	});
}
//#endregion
//#region src/components/HomePage/NavigationGroup.tsx
function NavigationGroup({ children, group, minimised, isPreview, isPotentialCardDropTarget, onEditGroup, dndDisabled, collapsed, onToggleCollapsed }) {
	const groupLabel = useNavigationGroupLabel();
	const [isHovered, setIsHovered] = useState(false);
	/**
	* The group's *name*, which is an identifier — it is what `onEditGroup`
	* renames, what the card ordering compares, and what the drawer keys its
	* icons off. Never the translated heading.
	*/
	const currentGroupName = group ?? "Views";
	/**
	* What the heading reads.
	*
	* This used to translate only the default group (`t("views_group")`) and
	* render every other name raw, while the drawer used
	* `useNavigationGroupLabel` — so the same three groups had two sets of
	* labels on one screen: `VISTAS / DATABASE / SETTINGS` on the home page
	* against `VIEWS / BASE DE DATOS / SETTINGS` in the drawer beside it. One
	* lookup, in both places.
	*/
	const currentGroupLabel = groupLabel(currentGroupName);
	const showCaret = !isPreview && !!onToggleCollapsed;
	const TitleContent = /* @__PURE__ */ jsxs("div", {
		className: cls("flex items-center", isPreview ? "px-1 py-0.5" : ""),
		children: [/* @__PURE__ */ jsx(Typography, {
			variant: isPreview ? "body2" : "caption",
			component: "h2",
			color: "secondary",
			className: cls("px-4 py-1 rounded", "font-medium text-[10px] uppercase tracking-[0.08em] text-surface-400 dark:text-surface-400"),
			children: currentGroupLabel
		}), !isPreview && onEditGroup && !dndDisabled && /* @__PURE__ */ jsx(IconButton, {
			size: "smallest",
			onClick: (e) => {
				e.stopPropagation();
				onEditGroup(currentGroupName);
			},
			className: cls("ml-2 ", isHovered ? "opacity-100" : "opacity-0", "transition-opacity duration-100"),
			children: /* @__PURE__ */ jsx(PencilIcon, { size: iconSize.smallest })
		})]
	});
	return /* @__PURE__ */ jsxs("div", {
		className: cls(!isPotentialCardDropTarget ? "my-10" : "my-6", "transition-all duration-200 ease-in-out"),
		children: [
			isPreview && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("div", {
				className: cls("flex items-center justify-between w-full", "p-4 py-2"),
				onMouseEnter: () => setIsHovered(true),
				onMouseLeave: () => setIsHovered(false),
				children: TitleContent
			}), children] }),
			!isPreview && showCaret && /* @__PURE__ */ jsx(ExpandablePanel, {
				invisible: true,
				expanded: !collapsed,
				onExpandedChange: (open) => {
					if (open !== !collapsed) onToggleCollapsed?.();
				},
				className: cls("mt-6"),
				titleClassName: cls("min-h-0 p-0 border-none", "rounded flex items-center justify-between w-full", "hover:bg-transparent", "cursor-pointer select-none", collapsed && "bg-surface-field"),
				innerClassName: cls("mt-4", !minimised ? "pt-0" : ""),
				title: /* @__PURE__ */ jsx("div", {
					onMouseEnter: () => setIsHovered(true),
					onMouseLeave: () => setIsHovered(false),
					className: "flex items-center",
					children: TitleContent
				}),
				children: minimised ? /* @__PURE__ */ jsx("div", {
					className: cls("mt-4 p-8 bg-surface-raised rounded-lg"),
					style: { minHeight: "50px" }
				}) : /* @__PURE__ */ jsx("div", {
					className: cls("mt-4", !minimised ? "pt-0" : ""),
					children
				})
			}),
			!isPreview && !showCaret && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("div", {
				className: cls("flex items-center justify-between w-full", "mt-6"),
				onMouseEnter: () => setIsHovered(true),
				onMouseLeave: () => setIsHovered(false),
				children: TitleContent
			}), !collapsed && (minimised ? /* @__PURE__ */ jsx("div", {
				className: cls("mt-4 p-8 bg-surface-raised rounded-lg"),
				style: { minHeight: "50px" }
			}) : /* @__PURE__ */ jsx("div", {
				className: cls("mt-4", !minimised ? "pt-0" : ""),
				children
			}))] })
		]
	});
}
//#endregion
//#region src/components/HomePage/NavigationCard.tsx
var NavigationCard = React.memo(function NavigationCard({ name, description, icon, actions, additionalContent, onClick, shrink }) {
	return /* @__PURE__ */ jsx(Card, {
		className: cls("group h-full p-4 cursor-pointer transition-colors duration-150 ease-in-out", shrink && "w-full max-w-full min-h-0 scale-75"),
		onClick: () => {
			onClick?.();
		},
		children: /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col h-full",
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: "flex items-center w-full justify-between mb-1",
					children: [/* @__PURE__ */ jsxs("div", {
						className: "flex items-center gap-3",
						children: [/* @__PURE__ */ jsx("div", {
							className: "flex items-center justify-center w-5 h-5 text-surface-400 dark:text-surface-500 transition-colors duration-150 group-hover:text-primary dark:group-hover:text-primary",
							children: icon
						}), /* @__PURE__ */ jsx(Typography, {
							variant: "subtitle1",
							component: "h2",
							children: name
						})]
					}), /* @__PURE__ */ jsx("div", {
						className: "flex items-center gap-0.5",
						onClick: (event) => {
							event.preventDefault();
							event.stopPropagation();
						},
						children: actions
					})]
				}),
				/* @__PURE__ */ jsx("div", {
					className: "pl-8",
					children: description && /* @__PURE__ */ jsx(Typography, {
						variant: "caption",
						color: "secondary",
						component: "div",
						children: /* @__PURE__ */ jsx(Markdown, {
							source: description,
							size: "small"
						})
					})
				}),
				additionalContent && /* @__PURE__ */ jsx("div", {
					className: "pl-8 pointer-events-none",
					children: additionalContent
				}),
				/* @__PURE__ */ jsx("div", { className: "grow" })
			]
		})
	});
});
//#endregion
//#region src/components/HomePage/NavigationCardBinding.tsx
/**
* This is the component used in the home page to render a card for each
* collection or view.
* @group Components
* @param view
* @param path
* @param collection
* @param url
* @param name
* @param description
* @param onClick

*/
function NavigationCardBinding({ slug, collection, view, url, name, description, onClick, type, shrink }) {
	const userConfigurationPersistence = useUserConfigurationPersistence();
	const collectionIcon = /* @__PURE__ */ jsx(IconForView, {
		collectionOrView: collection ?? view,
		size: "small"
	});
	const navigate = useNavigate();
	const context = useRebaseContext();
	const favourite = (userConfigurationPersistence?.favouritePaths ?? []).includes(slug);
	const actionsArray = userConfigurationPersistence ? [/* @__PURE__ */ jsx(IconButton, {
		size: "small",
		onClick: (e) => {
			e.preventDefault();
			e.stopPropagation();
			if (favourite) userConfigurationPersistence.setFavouritePaths(userConfigurationPersistence.favouritePaths.filter((p) => p !== slug));
			else userConfigurationPersistence.setFavouritePaths([...userConfigurationPersistence.favouritePaths, slug]);
		},
		children: /* @__PURE__ */ jsx(StarIcon, { className: favourite ? "text-secondary" : "text-surface-400 dark:text-surface-500" })
	}, "favourite")] : [];
	const pluginCardActions = useSlot("home.collection.actions", {
		slug,
		collection,
		context
	});
	const pluginCardWidgets = useSlot("home.card.widget", {
		slug,
		collection,
		context
	});
	return /* @__PURE__ */ jsx(NavigationCard, {
		icon: collectionIcon,
		name,
		description,
		actions: /* @__PURE__ */ jsxs(Fragment, { children: [actionsArray, pluginCardActions] }),
		additionalContent: pluginCardWidgets.length > 0 ? /* @__PURE__ */ jsx(Fragment, { children: pluginCardWidgets }) : void 0,
		onClick: () => {
			onClick?.();
			navigate(url);
			if (userConfigurationPersistence) userConfigurationPersistence.setRecentlyVisitedPaths([slug, ...(userConfigurationPersistence.recentlyVisitedPaths ?? []).filter((p) => p !== slug)]);
		},
		shrink
	});
}
//#endregion
//#region src/components/HomePage/HomePageDnD.tsx
var animateLayoutChanges = (args) => defaultAnimateLayoutChanges({
	...args,
	wasDragging: true
});
var dropAnimationConfig = {};
var cloneSerializableNavigationEntry = (entry) => {
	return {
		id: entry.id,
		slug: entry.slug,
		url: entry.url,
		name: entry.name,
		type: entry.type,
		collection: entry.collection ? { ...entry.collection } : void 0,
		view: entry.view ? { ...entry.view } : void 0,
		...entry.group && { group: entry.group },
		...entry.description && { description: entry.description }
	};
};
var cloneItemsForDnd = (items) => items.map((g) => ({
	name: g.name,
	entries: g.entries.map(cloneSerializableNavigationEntry)
}));
/**
* dnd-kit's `attributes`, minus the `role` it assumes.
*
* The wrapper these land on contains a `<Link>` and the card's own action
* buttons, and dnd-kit's `role: "button"` therefore declared a button
* containing a link containing more buttons. Measured on a scaffold's home
* page: 17 focusables for 5 destinations, 13 of the 17 `[role=button]` nested
* inside another — which is what a screen reader has to read through before it
* reaches the collection you wanted.
*
* The rest is kept, and it is the part that carries meaning:
* `aria-roledescription="sortable"`, the instructions dnd-kit points
* `aria-describedby` at, and the `tabIndex` its keyboard sensor needs — drag
* still works from the keyboard.
*
* A dedicated drag handle is the better answer and the one dnd-kit documents;
* it needs a control designed into the card, which is a visual change and not
* this one.
*/
function draggableAttributes(attributes) {
	const { role: _role, ...rest } = attributes;
	return rest;
}
function SortableNavigationCard({ entry, onClick }) {
	const { setNodeRef, listeners, attributes, transform, transition, isDragging } = useSortable({
		id: entry.url,
		animateLayoutChanges
	});
	return /* @__PURE__ */ jsx("div", {
		ref: setNodeRef,
		style: {
			transform: transform ? CSS.Transform.toString(transform) : void 0,
			transition,
			opacity: isDragging ? 0 : 1
		},
		...draggableAttributes(attributes),
		...listeners,
		children: /* @__PURE__ */ jsx(NavigationCardBinding, {
			...entry,
			onClick
		})
	});
}
function NavigationGroupDroppable({ id, itemIds, children, isPotentialCardDropTarget = false }) {
	const { setNodeRef } = useDroppable({ id });
	return /* @__PURE__ */ jsx("div", {
		ref: setNodeRef,
		className: cls(isPotentialCardDropTarget ? "p-2 bg-surface-raised rounded-lg" : void 0, "transition-all duration-200 ease-in-out"),
		children: /* @__PURE__ */ jsx(SortableContext, {
			items: itemIds,
			strategy: rectSortingStrategy,
			children
		})
	});
}
function SortableNavigationGroup({ groupName, children, disabled }) {
	const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
		id: groupName,
		animateLayoutChanges,
		disabled
	});
	return /* @__PURE__ */ jsx("div", {
		ref: setNodeRef,
		style: {
			transform: transform ? CSS.Transform.toString(transform) : void 0,
			transition,
			opacity: isDragging ? 0 : 1
		},
		...draggableAttributes(attributes),
		...listeners,
		children
	});
}
function useHomePageDnd({ items, setItems, disabled, onCardMovedBetweenGroups, onGroupMoved, onNewGroupDrop, onPersist }) {
	const dndItems = items;
	const setDndItems = setItems;
	const [activeId, setActiveId] = useState(null);
	const [activeIsGroup, setActiveIsGroup] = useState(false);
	const [currentDraggingGroupId, setCurrentDraggingGroupId] = useState(null);
	const [dndKitActiveNode, setDndKitActiveNode] = useState(null);
	const [isDraggingCardOnly, setIsDraggingCardOnly] = useState(false);
	const [dialogOpenForGroup, setDialogOpenForGroup] = useState(null);
	const [isHoveringNewGroupDropZone, setIsHoveringNewGroupDropZone] = useState(false);
	const [pendingNewGroupName, setPendingNewGroupName] = useState(null);
	const [stateBeforeNewGroup, setStateBeforeNewGroup] = useState(null);
	const preDragItemsRef = useRef(null);
	const interimItemsRef = useRef(null);
	useEffect(() => {
		interimItemsRef.current = dndItems;
	}, [dndItems]);
	const sensors = useSensors(useSensor(MouseSensor, { activationConstraint: { distance: 10 } }), useSensor(TouchSensor, { activationConstraint: {
		delay: 150,
		tolerance: 5
	} }), useSensor(KeyboardSensor));
	const dndContainers = dndItems.map((g) => g.name);
	const findDndContainer = useCallback((id) => {
		if (!id) return void 0;
		const group = dndItems.find((g) => g.name === id);
		if (group) return group.name;
		for (const g of dndItems) if (g.entries.some((e) => e.url === id)) return g.name;
	}, [dndItems]);
	const lastOverId = useRef(null);
	const recentlyMovedToNewContainer = useRef(false);
	const collisionDetection = useCallback((args) => {
		if (disabled || !activeId) return [];
		if (activeIsGroup) {
			const groups = args.droppableContainers.filter((c) => dndItems.some((g) => g.name === c.id));
			if (!groups.length) return [];
			return closestCenter({
				...args,
				droppableContainers: groups
			});
		}
		const pointer = pointerWithin(args);
		if (pointer.length) {
			const zone = pointer.find((c) => c.id === "new-group-drop-zone");
			if (zone) return [zone];
			const container = pointer.find((c) => dndItems.some((g) => g.name === c.id));
			if (container) {
				const itemsIn = dndItems.find((g) => g.name === container.id)?.entries;
				if (itemsIn?.length) {
					const closest = closestCorners({
						...args,
						droppableContainers: args.droppableContainers.filter((c) => itemsIn.some((e) => e.url === c.id))
					});
					if (closest.length) return closest;
				}
				return [container];
			}
			const first = getFirstCollision(pointer, "id");
			if (first) return [{ id: first }];
		}
		const rects = rectIntersection(args);
		const zoneRect = rects.find((c) => c.id === "new-group-drop-zone");
		if (zoneRect) return [zoneRect];
		let overId = getFirstCollision(rects, "id");
		if (overId != null) {
			if (dndItems.some((g) => g.name === overId)) {
				const itemsIn = dndItems.find((g) => g.name === overId)?.entries;
				if (itemsIn?.length) {
					const closestItem = closestCorners({
						...args,
						droppableContainers: args.droppableContainers.filter((c) => itemsIn.some((e) => e.url === c.id))
					})[0]?.id;
					if (closestItem) overId = closestItem;
				}
			}
			lastOverId.current = overId;
			return [{ id: overId }];
		}
		if (recentlyMovedToNewContainer.current && lastOverId.current && !activeIsGroup) return [{ id: lastOverId.current }];
		return [];
	}, [
		activeId,
		dndItems,
		disabled,
		activeIsGroup
	]);
	const handleDragStart = ({ active }) => {
		setDndKitActiveNode(active);
		if (disabled) return;
		preDragItemsRef.current = cloneItemsForDnd(dndItems);
		const isGroup = dndItems.some((g) => g.name === active.id);
		if (!active.data.current) active.data.current = {};
		active.data.current.type = isGroup ? "group" : "item";
		setActiveId(active.id);
		setActiveIsGroup(isGroup);
		setIsDraggingCardOnly(!isGroup);
		if (isGroup) setCurrentDraggingGroupId(active.id);
		recentlyMovedToNewContainer.current = false;
	};
	const handleDragOver = ({ active, over }) => {
		if (disabled || !over) return;
		const activeIdNow = active.id;
		const overIdNow = over.id;
		if (activeIdNow === overIdNow) return;
		if (activeIsGroup) return;
		const activeCont = findDndContainer(activeIdNow);
		const overCont = findDndContainer(overIdNow);
		if (!activeCont) return;
		if (overCont && activeCont !== overCont) {
			recentlyMovedToNewContainer.current = true;
			lastOverId.current = overIdNow;
			setDndItems((current) => {
				const newState = cloneItemsForDnd(current);
				const srcIdx = newState.findIndex((g) => g.name === activeCont);
				const tgtIdx = newState.findIndex((g) => g.name === overCont);
				if (srcIdx === -1 || tgtIdx === -1) return current;
				const src = newState[srcIdx];
				const tgt = newState[tgtIdx];
				const idxInSrc = src.entries.findIndex((e) => e.url === activeIdNow);
				if (idxInSrc === -1) return current;
				const [moved] = src.entries.splice(idxInSrc, 1);
				if (overIdNow === overCont) tgt.entries.push(moved);
				else {
					const overIdx = tgt.entries.findIndex((e) => e.url === overIdNow);
					if (overIdx !== -1) tgt.entries.splice(overIdx, 0, moved);
					else tgt.entries.push(moved);
				}
				return newState;
			});
		} else if (activeCont === overCont) recentlyMovedToNewContainer.current = false;
	};
	const handleDragEnd = ({ active, over }) => {
		if (disabled || !over) {
			resetDragState();
			return;
		}
		const activeIdNow = active.id;
		const overIdNow = over.id;
		if (activeIsGroup) {
			if (activeIdNow !== overIdNow && dndItems.some((g) => g.name === overIdNow)) {
				const from = dndItems.findIndex((g) => g.name === activeIdNow);
				const to = dndItems.findIndex((g) => g.name === overIdNow);
				if (from !== -1 && to !== -1) {
					const newState = arrayMove(dndItems, from, to);
					setDndItems(newState);
					onPersist?.(newState);
					onGroupMoved?.(activeIdNow, from, to);
				}
			}
		} else {
			const findContainerInState = (id, state) => {
				const group = state.find((g) => g.name === id);
				if (group) return group.name;
				for (const g of state) if (g.entries.some((e) => e.url === id)) return g.name;
			};
			const sourceState = preDragItemsRef.current || dndItems;
			const activeCont = findContainerInState(activeIdNow, sourceState);
			findDndContainer(overIdNow);
			if (overIdNow === "new-group-drop-zone") {
				if (activeCont) {
					setStateBeforeNewGroup(cloneItemsForDnd(dndItems));
					const newState = cloneItemsForDnd(dndItems);
					const srcIdx = newState.findIndex((g) => g.name === activeCont);
					if (srcIdx !== -1) {
						const src = newState[srcIdx];
						const idxInSrc = src.entries.findIndex((e) => e.url === activeIdNow);
						if (idxInSrc !== -1) {
							const [dragged] = src.entries.splice(idxInSrc, 1);
							if (src.entries.length === 0) newState.splice(srcIdx, 1);
							let tentative = "New Group";
							let counter = 1;
							while (newState.some((g) => g.name === tentative)) tentative = `New Group ${counter++}`;
							newState.push({
								name: tentative,
								entries: [dragged]
							});
							setDndItems(newState);
							setPendingNewGroupName(tentative);
							setDialogOpenForGroup(tentative);
							onNewGroupDrop?.();
						}
					}
				}
			} else {
				const overCont = findDndContainer(overIdNow);
				if (activeCont === overCont) {
					const grpIdx = dndItems.findIndex((g) => g.name === activeCont);
					if (grpIdx !== -1) {
						const group = dndItems[grpIdx];
						const oldIdx = group.entries.findIndex((e) => e.url === activeIdNow);
						let newIdx = group.entries.findIndex((e) => e.url === overIdNow);
						if (newIdx === -1 && overIdNow === activeCont) newIdx = group.entries.length - 1;
						if (oldIdx !== -1 && newIdx !== -1 && oldIdx !== newIdx) {
							const reordered = arrayMove(group.entries, oldIdx, newIdx);
							const newState = [...dndItems];
							newState[grpIdx] = {
								...group,
								entries: reordered
							};
							setDndItems(newState);
							onPersist?.(newState);
						}
					}
				} else if (overCont && activeCont !== overCont) {
					const finalState = cloneItemsForDnd(sourceState);
					const finalOverId = lastOverId.current || overIdNow;
					const cleanOverCont = findContainerInState(finalOverId, sourceState) || overCont;
					const srcIdx = finalState.findIndex((g) => g.name === activeCont);
					const tgtIdx = finalState.findIndex((g) => g.name === cleanOverCont);
					if (srcIdx !== -1 && tgtIdx !== -1) {
						const src = finalState[srcIdx];
						const tgt = finalState[tgtIdx];
						const idxInSrc = src.entries.findIndex((e) => e.url === activeIdNow);
						if (idxInSrc !== -1) {
							const [moved] = src.entries.splice(idxInSrc, 1);
							if (finalOverId === cleanOverCont) tgt.entries.push(moved);
							else {
								const overIdx = tgt.entries.findIndex((e) => e.url === finalOverId);
								if (overIdx !== -1) tgt.entries.splice(overIdx, 0, moved);
								else tgt.entries.push(moved);
							}
							if (src.entries.length === 0) finalState.splice(srcIdx, 1);
							setDndItems(finalState);
							onPersist?.(finalState);
							onCardMovedBetweenGroups?.(moved);
						}
					}
				} else if (recentlyMovedToNewContainer.current) console.error("Move between containers detected but conditions not met", {
					activeCont,
					overCont,
					activeIdNow,
					overIdNow
				});
			}
		}
		resetDragState();
	};
	const resetDragState = () => {
		setDndKitActiveNode(null);
		setActiveId(null);
		setActiveIsGroup(false);
		setCurrentDraggingGroupId(null);
		setIsDraggingCardOnly(false);
		recentlyMovedToNewContainer.current = false;
	};
	const handleDragCancel = () => resetDragState();
	const handleRenameGroup = (oldName, newName) => {
		setDndItems((current) => {
			const idx = current.findIndex((g) => g.name === oldName);
			if (idx === -1) return current;
			if (current.some((g) => g.name === newName && g.name !== oldName)) return current;
			const updated = [...current];
			updated[idx] = {
				...updated[idx],
				name: newName
			};
			onPersist?.(updated);
			return updated;
		});
		setPendingNewGroupName(null);
		setStateBeforeNewGroup(null);
		setDialogOpenForGroup(null);
	};
	const handleDialogClose = () => {
		if (pendingNewGroupName && dialogOpenForGroup === pendingNewGroupName && stateBeforeNewGroup) setDndItems(stateBeforeNewGroup);
		setPendingNewGroupName(null);
		setStateBeforeNewGroup(null);
		setDialogOpenForGroup(null);
	};
	return {
		sensors,
		collisionDetection,
		onDragStart: handleDragStart,
		onDragOver: handleDragOver,
		onDragEnd: handleDragEnd,
		onDragCancel: handleDragCancel,
		dropAnimation: dropAnimationConfig,
		activeItemForOverlay: disabled || !activeId || activeIsGroup ? null : dndItems.flatMap((g) => g.entries).find((e) => e.url === activeId) || null,
		activeGroupData: disabled || !activeId || !activeIsGroup ? null : dndItems.find((g) => g.name === activeId) || null,
		draggingGroupId: currentDraggingGroupId,
		containers: dndContainers,
		dndKitActiveNode,
		isDraggingCardOnly,
		dialogOpenForGroup,
		setDialogOpenForGroup,
		handleRenameGroup,
		handleDialogClose,
		isHoveringNewGroupDropZone,
		setIsHoveringNewGroupDropZone
	};
}
function NewGroupDropZone({ disabled, setIsHovering }) {
	const { setNodeRef, isOver } = useDroppable({
		id: "new-group-drop-zone",
		disabled
	});
	const [isVisible, setIsVisible] = useState(false);
	useDndMonitor({
		onDragStart({ active }) {
			if (disabled) return;
			const tp = active.data.current?.type;
			setIsVisible(tp === "item");
		},
		onDragEnd() {
			setIsVisible(false);
		},
		onDragCancel() {
			setIsVisible(false);
		}
	});
	useEffect(() => {
		setIsHovering(isOver && isVisible);
	}, [
		isOver,
		isVisible,
		setIsHovering
	]);
	if (!isVisible || disabled) return null;
	return /* @__PURE__ */ jsx("div", {
		ref: setNodeRef,
		className: cls("fixed right-8 top-1/2 -translate-y-1/2 w-[200px] h-[120px] border border-dashed rounded-lg flex items-center justify-center transition-all", isOver ? "bg-surface-raised border-hairline-strong" : "bg-surface-card border-hairline-strong"),
		children: /* @__PURE__ */ jsx("div", {
			className: "text-center p-4",
			children: /* @__PURE__ */ jsx("span", {
				className: "block font-medium text-sm",
				children: "Drop here to create a new group"
			})
		})
	});
}
//#endregion
//#region src/components/HomePage/RenameGroupDialog.tsx
function RenameGroupDialog({ open, initialName, existingGroupNames, onClose, onRename }) {
	const { t } = useTranslation();
	const [name, setName] = useState(initialName);
	const [error, setError] = useState(null);
	const inputRef = useRef(null);
	useEffect(() => {
		if (open) {
			setName(initialName);
			setError(null);
			setTimeout(() => {
				if (inputRef.current) {
					inputRef.current.focus();
					inputRef.current.select();
				}
			}, 100);
		}
	}, [initialName, open]);
	const handleNameChange = (event) => {
		const newName = event.target.value;
		setName(newName);
		if (!newName.trim()) setError(t("group_name_empty_error"));
		else if (existingGroupNames.includes(newName.trim())) setError(t("group_name_exists_error"));
		else setError(null);
	};
	const handleSave = () => {
		const trimmedName = name.trim();
		if (!trimmedName) {
			setError(t("group_name_empty_error"));
			return;
		}
		if (existingGroupNames.includes(trimmedName)) {
			setError(t("group_name_exists_error"));
			return;
		}
		if (!error) {
			onRename(trimmedName);
			onClose();
		}
	};
	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
			const trimmedName = name.trim();
			let currentError = null;
			if (!trimmedName) currentError = t("group_name_empty_error");
			else if (existingGroupNames.includes(trimmedName)) currentError = t("group_name_exists_error");
			if (!currentError && trimmedName) handleSave();
			else if (currentError) setError(currentError);
		}
	};
	if (!open) return null;
	return /* @__PURE__ */ jsxs(Dialog, {
		open,
		children: [
			/* @__PURE__ */ jsx(DialogTitle, { children: t("rename_group") }),
			/* @__PURE__ */ jsxs(DialogContent, { children: [/* @__PURE__ */ jsx(TextField, {
				inputRef,
				label: t("group_name_label"),
				value: name,
				onChange: handleNameChange,
				onKeyDown: handleKeyDown,
				error: !!error,
				"aria-describedby": error ? "group-name-error" : void 0
			}), error && /* @__PURE__ */ jsx("p", {
				id: "group-name-error",
				style: { display: "none" },
				children: error
			})] }),
			/* @__PURE__ */ jsxs(DialogActions, { children: [/* @__PURE__ */ jsx(Button, {
				onClick: onClose,
				variant: "text",
				children: t("cancel")
			}), /* @__PURE__ */ jsx(Button, {
				onClick: handleSave,
				disabled: !!error || !name.trim(),
				children: t("save")
			})] })
		]
	});
}
//#endregion
//#region src/components/HomePage/ContentHomePage.tsx
var DEFAULT_GROUP_NAME = "Views";
var ADMIN_GROUP_NAME = "Admin";
function ContentHomePage({ additionalActions, additionalChildrenStart, additionalChildrenEnd, sections, hiddenGroups }) {
	const context = useAdminContext();
	const { navigationStateController } = context;
	const customizationController = useCustomizationController();
	const adminModeController = useAdminModeController();
	const registry = useRebaseRegistry();
	const { resolvedSlots } = customizationController;
	const breadcrumbs = useBreadcrumbsController();
	const { t } = useTranslation();
	useEffect(() => {
		breadcrumbs.set({ breadcrumbs: [] });
	}, [breadcrumbs.set]);
	const { allowDragAndDrop = false, navigationEntries: unFilteredNavigationEntries = [], groups: unFilteredGroupOrder = [], onNavigationEntriesUpdate = () => {} } = navigationStateController.topLevelNavigation || {};
	const studioViewSlugs = useMemo(() => {
		const slugs = /* @__PURE__ */ new Set();
		(registry.studioConfig?.devViews ?? []).forEach((v) => slugs.add(v.slug));
		if (registry.studioConfig && registry.cmsConfig?.collectionEditor) slugs.add("schema");
		return slugs;
	}, [registry.studioConfig, registry.cmsConfig?.collectionEditor]);
	const rawNavigationEntries = useMemo(() => {
		if (adminModeController.mode === "studio") return unFilteredNavigationEntries.filter((e) => e.type === "view" && studioViewSlugs.has(e.slug) || e.type === "admin");
		return unFilteredNavigationEntries.filter((e) => e.type !== "view" || !studioViewSlugs.has(e.slug));
	}, [
		unFilteredNavigationEntries,
		adminModeController.mode,
		studioViewSlugs
	]);
	const groupOrderFromNavController = useMemo(() => {
		const entryGroups = new Set(rawNavigationEntries.map((e) => e.group).filter(Boolean));
		return unFilteredGroupOrder.filter((g) => entryGroups.has(g));
	}, [unFilteredGroupOrder, rawNavigationEntries]);
	const fuse = useRef(null);
	const [filteredUrls, setFilteredUrls] = useState(null);
	const performingSearch = Boolean(filteredUrls);
	const filteredNavigationEntries = useMemo(() => {
		return filteredUrls ? rawNavigationEntries.filter((e) => filteredUrls.includes(e.url)) : rawNavigationEntries;
	}, [filteredUrls, rawNavigationEntries]);
	useEffect(() => {
		fuse.current = new Fuse(rawNavigationEntries, { keys: [
			"name",
			"description",
			"group",
			"path"
		] });
	}, [rawNavigationEntries]);
	const updateSearch = useCallback((v) => {
		if (!v?.trim()) {
			setFilteredUrls(null);
			return;
		}
		const results = fuse.current?.search(v.trim());
		setFilteredUrls(results ? results.map((x) => x.item.url) : []);
	}, []);
	const [items, setItems] = useState([]);
	const [adminGroupData, setAdminGroupData] = useState(null);
	const isDndDirtyRef = useRef(false);
	const dndDirtyTimeoutRef = useRef(null);
	const processedGroups = useMemo(() => {
		const src = filteredNavigationEntries;
		const entriesByGroup = {};
		src.forEach((e) => {
			const g = e.type === "admin" ? ADMIN_GROUP_NAME : e.group ?? "Views";
			(entriesByGroup[g] ??= []).push(e);
		});
		const hasPluginAdditionalCards = customizationController.resolvedSlots.some((s) => s.slot === "home.cards");
		let allProcessed;
		if (performingSearch) allProcessed = [...new Set(src.map((e) => e.group ?? "Views"))].map((name) => ({
			name,
			entries: entriesByGroup[name] || []
		})).filter((g) => g.entries.length);
		else {
			allProcessed = groupOrderFromNavController.map((g) => ({
				name: g,
				entries: entriesByGroup[g] || []
			}));
			Object.keys(entriesByGroup).forEach((g) => {
				if (!groupOrderFromNavController.includes(g)) allProcessed.push({
					name: g,
					entries: entriesByGroup[g]
				});
			});
			if (hasPluginAdditionalCards && !allProcessed.some((g) => g.name === "Views")) allProcessed.push({
				name: DEFAULT_GROUP_NAME,
				entries: []
			});
			allProcessed = allProcessed.filter((g) => g.entries.length || g.name === "Views" && hasPluginAdditionalCards);
		}
		return {
			adminGroupData: allProcessed.find((g) => g.name === "Admin") || null,
			items: allProcessed.filter((g) => g.name !== "Admin" && !hiddenGroups?.includes(g.name))
		};
	}, [
		filteredNavigationEntries,
		performingSearch,
		groupOrderFromNavController,
		customizationController.resolvedSlots,
		hiddenGroups
	]);
	useEffect(() => {
		if (isDndDirtyRef.current) return;
		setAdminGroupData(processedGroups.adminGroupData);
		setItems(processedGroups.items);
	}, [processedGroups]);
	const updateItems = (updater) => {
		setItems(updater);
	};
	const persistNavigationGroups = (latest) => {
		isDndDirtyRef.current = true;
		if (dndDirtyTimeoutRef.current) clearTimeout(dndDirtyTimeoutRef.current);
		dndDirtyTimeoutRef.current = setTimeout(() => {
			isDndDirtyRef.current = false;
		}, 1e3);
		const draggable = latest.map((g) => ({
			name: g.name,
			entries: g.entries.map((e) => e.slug)
		}));
		const all = adminGroupData ? [...draggable, {
			name: adminGroupData.name,
			entries: adminGroupData.entries.map((e) => e.slug)
		}] : draggable;
		onNavigationEntriesUpdate(all);
	};
	const { isGroupCollapsed, toggleGroupCollapsed } = useCollapsedGroups(useMemo(() => [...items.map((item) => item.name), ...adminGroupData ? [adminGroupData.name] : []], [items, adminGroupData]), "home", useMemo(() => buildCollapsedDefaults(registry.cmsConfig?.navigationGroupMappings, "home"), [registry.cmsConfig?.navigationGroupMappings]));
	const { sensors, collisionDetection, onDragStart, onDragOver, onDragEnd, dropAnimation, activeItemForOverlay, activeGroupData, draggingGroupId, containers, dndKitActiveNode, onDragCancel, isDraggingCardOnly, dialogOpenForGroup, setDialogOpenForGroup, handleRenameGroup, handleDialogClose, isHoveringNewGroupDropZone, setIsHoveringNewGroupDropZone } = useHomePageDnd({
		items,
		setItems: updateItems,
		disabled: !allowDragAndDrop || performingSearch,
		onPersist: persistNavigationGroups,
		onGroupMoved: (g) => context.analyticsController?.onAnalyticsEvent?.("home_move_group", { name: g }),
		onCardMovedBetweenGroups: (card) => context.analyticsController?.onAnalyticsEvent?.("home_move_card", { id: card.id }),
		onNewGroupDrop: () => context.analyticsController?.onAnalyticsEvent?.("home_drop_new_group")
	});
	const { containerRef, direction } = useRestoreScroll();
	const dndDisabled = !allowDragAndDrop || performingSearch;
	const dndModifiers = dndKitActiveNode?.data.current?.type === "group" ? [restrictToVerticalAxis, restrictToWindowEdges] : [restrictToWindowEdges];
	const sectionProps = { context };
	const additionalPluginChildrenStart = useSlot("home.children.start", sectionProps);
	const additionalPluginChildrenEnd = useSlot("home.children.end", sectionProps);
	const additionalPluginActions = useSlot("home.actions", sectionProps);
	const homeCardContributions = useMemo(() => {
		return resolvedSlots.filter((s) => s.slot === "home.cards").sort((a, b) => (a.order ?? 50) - (b.order ?? 50));
	}, [resolvedSlots]);
	return /* @__PURE__ */ jsxs("div", {
		ref: containerRef,
		className: "py-2 overflow-auto h-full w-full bg-surface-sheet",
		children: [/* @__PURE__ */ jsxs(Container, {
			maxWidth: "6xl",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: "mb-4 flex flex-col gap-2",
					children: /* @__PURE__ */ jsx(SchemaDriftBanner, {})
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "w-full sticky py-4 transition-all duration-400 ease-in-out top-0 z-10 flex flex-row gap-4",
					style: { top: direction === "down" ? -84 : 0 },
					children: [
						/* @__PURE__ */ jsx(SearchBar, {
							onTextSearch: updateSearch,
							placeholder: t("search_collections"),
							autoFocus: true,
							size: "small",
							innerClassName: "w-full",
							className: "w-full grow"
						}),
						additionalActions,
						additionalPluginActions
					]
				}),
				/* @__PURE__ */ jsx(FavouritesView, { hidden: performingSearch }),
				additionalChildrenStart,
				additionalPluginChildrenStart,
				/* @__PURE__ */ jsxs(DndContext, {
					sensors,
					collisionDetection,
					measuring: { droppable: {
						strategy: MeasuringStrategy.Always,
						frequency: 500
					} },
					onDragStart,
					onDragOver,
					onDragEnd,
					onDragCancel,
					modifiers: dndModifiers,
					children: [
						/* @__PURE__ */ jsx(SortableContext, {
							items: containers,
							strategy: verticalListSortingStrategy,
							children: items.map((groupData, groupIndex) => {
								const groupKey = groupData.name;
								const entriesInGroup = groupData.entries;
								const homeCardsProps = {
									group: groupKey === "Views" ? void 0 : groupKey,
									context
								};
								const additionalCards = homeCardContributions.map((s, i) => /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(s.Component, {
									...homeCardsProps,
									...s.props ?? {}
								}) }, `home_cards_${groupKey}_${i}`));
								if (entriesInGroup.length === 0 && (additionalCards.length === 0 || performingSearch)) return null;
								return /* @__PURE__ */ jsx(SortableNavigationGroup, {
									groupName: groupKey,
									disabled: dndDisabled,
									children: /* @__PURE__ */ jsx(NavigationGroup, {
										group: groupKey === "Views" ? void 0 : groupKey,
										minimised: draggingGroupId === groupKey && !isDraggingCardOnly,
										isPotentialCardDropTarget: isDraggingCardOnly,
										dndDisabled,
										onEditGroup: () => {
											if (dndDisabled) return;
											setDialogOpenForGroup(groupKey);
										},
										collapsed: isGroupCollapsed(groupKey),
										onToggleCollapsed: () => toggleGroupCollapsed(groupKey),
										children: /* @__PURE__ */ jsx(NavigationGroupDroppable, {
											id: groupKey,
											itemIds: entriesInGroup.map((e) => e.url),
											isPotentialCardDropTarget: isDraggingCardOnly,
											children: /* @__PURE__ */ jsxs("div", {
												className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ",
												children: [entriesInGroup.map((entry) => /* @__PURE__ */ jsx(SortableNavigationCard, {
													entry,
													onClick: () => {
														let event = "unmapped_event";
														if (entry.type === "collection") event = "home_navigate_to_collection";
														else if (entry.type === "view") event = "home_navigate_to_view";
														else if (entry.type === "admin") event = "home_navigate_to_admin_view";
														context.analyticsController?.onAnalyticsEvent?.(event, { path: entry.slug });
													}
												}, entry.url)), !performingSearch && groupKey.toLowerCase() !== "Admin".toLowerCase() && additionalCards]
											})
										})
									})
								}, `group-${groupIndex}`);
							})
						}, containers.join(",")),
						/* @__PURE__ */ jsx(NewGroupDropZone, {
							disabled: dndDisabled,
							setIsHovering: setIsHoveringNewGroupDropZone
						}),
						/* @__PURE__ */ jsx(DragOverlay, {
							adjustScale: false,
							dropAnimation,
							children: activeGroupData && draggingGroupId === activeGroupData.name ? /* @__PURE__ */ jsx("div", {
								className: "rounded-lg bg-transparent",
								style: {
									padding: 0,
									margin: 0
								},
								children: /* @__PURE__ */ jsx(NavigationGroup, {
									group: activeGroupData.name === "Views" ? void 0 : activeGroupData.name,
									isPreview: false,
									minimised: true
								})
							}) : activeItemForOverlay ? /* @__PURE__ */ jsx(NavigationCardBinding, {
								...activeItemForOverlay,
								shrink: isHoveringNewGroupDropZone
							}) : null
						})
					]
				}),
				!performingSearch && adminGroupData && /* @__PURE__ */ jsx(NavigationGroup, {
					group: adminGroupData.name,
					collapsed: isGroupCollapsed(adminGroupData.name),
					onToggleCollapsed: () => toggleGroupCollapsed(adminGroupData.name),
					children: /* @__PURE__ */ jsx("div", {
						className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ",
						children: adminGroupData.entries.map((entry) => /* @__PURE__ */ jsx(NavigationCardBinding, {
							...entry,
							onClick: () => {
								let event = "unmapped_event";
								if (entry.type === "collection") event = "home_navigate_to_collection";
								else if (entry.type === "view") event = "home_navigate_to_view";
								else if (entry.type === "admin") event = "home_navigate_to_admin_view";
								context.analyticsController?.onAnalyticsEvent?.(event, { path: entry.slug });
							}
						}, entry.url))
					})
				}),
				sections && sections.map((section) => /* @__PURE__ */ jsx(NavigationGroup, {
					group: section.title,
					children: section.children
				}, section.key)),
				additionalPluginChildrenEnd,
				additionalChildrenEnd
			]
		}), dialogOpenForGroup && /* @__PURE__ */ jsx(RenameGroupDialog, {
			open: true,
			initialName: dialogOpenForGroup,
			existingGroupNames: items.map((g) => g.name).filter((n) => n !== dialogOpenForGroup),
			onClose: handleDialogClose,
			onRename: (newName) => {
				handleRenameGroup(dialogOpenForGroup, newName);
			}
		})]
	});
}
//#endregion
//#region src/components/CollectionEditorDialogs.tsx
var CollectionEditorDialog = lazyChunk(() => import("./CollectionEditorDialog-CUtfS_49.js").then((n) => n.r).then((m) => ({ default: m.CollectionEditorDialog })));
var PropertyFormDialog = lazyChunk(() => import("./PropertyEditView-BpEbC0Q2.js").then((n) => n.t).then((m) => ({ default: m.PropertyFormDialog })));
/**
* Renders the CollectionEditorDialog and PropertyFormDialog inside
* the RebaseShell tree where admin-internal contexts
* (CollectionRegistryContext, NavigationStateContext, UrlContext)
* are available.
*
* Both dialog components are loaded dynamically via React.lazy so that
* production admin bundles that never open the collection editor don't pay
* the download/parse cost up-front.
*
* The dialog state (open/close, props) is managed by ConfigControllerProvider
* (a root-scope plugin provider that wraps the shell) and exposed via
* CollectionEditorDialogsContext.
*/
function CollectionEditorDialogs() {
	const state = useCollectionEditorDialogsState();
	if (!state) return null;
	const { collectionDialogProps, propertyDialogProps } = state;
	if (!(collectionDialogProps?.open || propertyDialogProps?.open)) return null;
	return /* @__PURE__ */ jsxs(Suspense, {
		fallback: null,
		children: [collectionDialogProps?.open && /* @__PURE__ */ jsx(CollectionEditorDialog, {
			open: false,
			isNewCollection: false,
			configController: void 0,
			handleClose: () => {},
			...collectionDialogProps
		}), propertyDialogProps?.open && /* @__PURE__ */ jsx(PropertyFormDialog, {
			open: false,
			existingProperty: false,
			autoOpenTypeSelect: false,
			inArray: false,
			allowDataInference: false,
			propertyConfigs: {},
			...propertyDialogProps
		})]
	});
}
//#endregion
//#region src/components/RebaseRouteDefs.tsx
function SettingsView() {
	const { t } = useTranslation();
	const breadcrumbs = useBreadcrumbsController();
	useEffect(() => {
		breadcrumbs.set({ breadcrumbs: [{
			title: t("account_settings"),
			url: "/settings"
		}] });
	}, []);
	return /* @__PURE__ */ jsx(UserSettingsView, {});
}
/**
* Route definitions for the admin.
*
* Defines all standard routes: home, studio home, collection view,
* settings, debug, custom views, and a catch-all 404.
*
* **Independently usable**: Use this when you want Rebase routes
* inside your own layout/navigation setup.
*
* @example
* ```tsx
* <RebaseNavigation>
*   <RebaseRouteDefs layout={<MyCustomLayout />}>
*     <Route path="/my-custom" element={<MyView />} />
*   </RebaseRouteDefs>
* </RebaseNavigation>
* ```
*/
function RebaseRouteDefs({ children, layout }) {
	const registry = useRebaseRegistry();
	const navigationStateController = useNavigationStateController();
	const ResolvedHomePage = useComponentOverride("HomePage", ContentHomePage);
	const cmsHomePage = registry.cmsConfig?.homePage ?? /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(CircularProgressCenter, {}),
		children: /* @__PURE__ */ jsx(ResolvedHomePage, {})
	});
	const studioHomePage = registry.studioConfig?.homePage;
	const combinedViews = useMemo(() => [...navigationStateController.views ?? [], ...navigationStateController.adminViews ?? []], [navigationStateController.views, navigationStateController.adminViews]);
	const routeContents = /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx(Route, {
			path: "/",
			element: cmsHomePage
		}),
		registry.studioConfig && /* @__PURE__ */ jsx(Route, {
			path: "/s",
			element: studioHomePage
		}),
		/* @__PURE__ */ jsx(Route, {
			path: "/c/*",
			element: /* @__PURE__ */ jsx(RebaseRoute, {})
		}),
		/* @__PURE__ */ jsx(Route, {
			path: "/settings",
			element: /* @__PURE__ */ jsx(SettingsView, {})
		}),
		combinedViews.map((view) => {
			return (Array.isArray(view.slug) ? view.slug : [view.slug]).flatMap((slug) => {
				const routes = [/* @__PURE__ */ jsx(Route, {
					path: slug,
					element: /* @__PURE__ */ jsx(CustomViewRoute, { view })
				}, slug)];
				if (view.nestedRoutes) routes.push(/* @__PURE__ */ jsx(Route, {
					path: slug + "/*",
					element: /* @__PURE__ */ jsx(CustomViewRoute, { view })
				}, slug + "/*"));
				return routes;
			});
		}),
		children,
		/* @__PURE__ */ jsx(Route, {
			path: "*",
			element: navigationStateController.loading ? /* @__PURE__ */ jsx(CircularProgressCenter, {}) : /* @__PURE__ */ jsx(NotFoundPage, {})
		})
	] });
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(RebaseRoutes, { children: layout ? /* @__PURE__ */ jsx(Route, {
		element: layout,
		children: routeContents
	}) : /* @__PURE__ */ jsx(Route, {
		element: /* @__PURE__ */ jsx(Fragment, { children: routeContents }),
		children: routeContents
	}) }), /* @__PURE__ */ jsx(CollectionEditorDialogs, {})] });
}
//#endregion
//#region src/components/RebaseShell.tsx
/**
* Convenience component that composes all four admin layers:
*
* ```
* <RebaseAuthGate>
*   <RebaseNavigation>
*     <RebaseRouteDefs layout={<RebaseLayout>}>
*       {children}
*     </RebaseRouteDefs>
*   </RebaseNavigation>
* </RebaseAuthGate>
* ```
*
* Each layer is independently usable — see their individual docs.
* RebaseShell is sugar that composes them all with sensible defaults.
*/
function RebaseShell(props) {
	const { title = "Rebase", appBar, drawer, autoOpenDrawer = true, defaultDrawerOpen = false, logo, children } = props;
	const registry = useRebaseRegistry();
	return /* @__PURE__ */ jsx(RebaseAuthGate, { children: /* @__PURE__ */ jsx(RebaseNavigation, { children: /* @__PURE__ */ jsx(ErrorBoundary, {
		fullPage: true,
		children: /* @__PURE__ */ jsx(RebaseRouteDefs, {
			layout: /* @__PURE__ */ jsx(RebaseLayout, {
				title,
				appBar,
				drawer,
				autoOpenDrawer,
				defaultDrawerOpen,
				logo,
				devViews: useMemo(() => {
					return registry.studioConfig?.devViews ?? [];
				}, [registry.studioConfig?.devViews])
			}),
			children
		})
	}) }) });
}
//#endregion
//#region src/components/CollectionPanel.tsx
/**
* A high-level, reusable wrapper for embedding a Rebase collection view
* inside custom pages (dashboards, home pages, entity detail views, etc.).
*
* Usage:
* ```tsx
* import { CollectionPanel } from "@rebasepro/cms";
*
* function MyDashboard() {
*     return (
*         <div>
*             <CollectionPanel path="tasks" title="Pending Tasks" />
*             <CollectionPanel
*                 path="clients"
*                 viewMode="table"
*                 collectionOverrides={{
*                     defaultFilter: { status: ["!=", "completed"] }
*                 }}
*             />
*         </div>
*     );
* }
* ```
*
* @group Components
*/
function CollectionPanelInner({ mergedCollection, path, title, updateUrl, className }) {
	const ResolvedCollectionView = useComponentOverride("Collection.View", CollectionViewBinding);
	return /* @__PURE__ */ jsxs("div", {
		className,
		children: [title !== false && /* @__PURE__ */ jsx(Typography, {
			variant: "subtitle2",
			className: "font-semibold mb-2 text-surface-700 dark:text-surface-300",
			children: title ?? mergedCollection.name
		}), /* @__PURE__ */ jsx(ResolvedCollectionView, {
			...mergedCollection,
			path,
			updateUrl
		})]
	});
}
function CollectionPanel(props) {
	const { path, viewMode, sort, limit, openEntityMode, className, collectionOverrides } = props;
	const registeredCollection = useCollectionRegistryController().getCollection(path);
	const mergedCollection = useMemo(() => {
		if (!registeredCollection) return void 0;
		const propOverrides = {};
		if (viewMode) propOverrides.defaultViewMode = viewMode;
		if (sort) propOverrides.sort = sort;
		if (limit) propOverrides.pagination = limit;
		if (openEntityMode) propOverrides.openEntityMode = openEntityMode;
		return {
			...registeredCollection,
			...collectionOverrides ?? {},
			...propOverrides
		};
	}, [
		registeredCollection,
		collectionOverrides,
		viewMode,
		sort,
		limit,
		openEntityMode
	]);
	if (!mergedCollection) return /* @__PURE__ */ jsx("div", {
		className,
		children: /* @__PURE__ */ jsxs(Typography, {
			variant: "body2",
			color: "secondary",
			children: [
				"Collection \"",
				path,
				"\" not found."
			]
		})
	});
	return /* @__PURE__ */ jsx(CollectionScopeProvider, {
		collection: mergedCollection,
		children: /* @__PURE__ */ jsx(CollectionPanelInner, {
			...props,
			mergedCollection
		})
	});
}
//#endregion
//#region src/util/propertyConfigMapper.ts
/**
* Map Rebase property types to headless-supported types.
* `vector` and `binary` are not directly renderable, so we fall back to `string`.
*/
var TYPE_MAP = {
	string: "string",
	number: "number",
	boolean: "boolean",
	date: "date",
	geopoint: "geopoint",
	reference: "reference",
	relation: "relation",
	array: "array",
	map: "map",
	vector: "string",
	binary: "string"
};
/**
* Convert a single Property to a CollectionPropertyConfig.
*/
function mapPropertyToConfig(property, key) {
	const base = {
		type: TYPE_MAP[property.type] ?? "string",
		name: property.name ?? (key ? prettifyIdentifier(key) : ""),
		description: property.description,
		columnWidth: property.admin?.columnWidth,
		hideFromCollection: property.admin?.hideFromCollection
	};
	if (property.type === "string") {
		if (property.enum) base.enum = mapEnumValues(property.enum);
		if (property.admin?.multiline) base.multiline = true;
		if (property.admin?.previewAsTag) base.previewAsTag = true;
		if (property.admin?.urlPreview) base.url = property.admin.urlPreview;
		if (property.admin?.markdown) base.markdown = true;
		if (property.storage) base.storage = true;
		if (property.email) base.email = true;
	}
	if (property.type === "number" && property.enum) base.enum = mapEnumValues(property.enum);
	if (property.type === "array" && property.of && !Array.isArray(property.of)) base.of = mapPropertyToConfig(property.of, key);
	if (property.type === "map" && property.properties) {
		base.properties = mapPropertiesToConfigs(property.properties);
		if (property.propertiesOrder) base.propertiesOrder = property.propertiesOrder;
	}
	if (property.type === "date" && property.mode) base.mode = property.mode;
	if (property.admin?.Preview) {}
	return base;
}
/**
* Convert a Properties record to a CollectionPropertyConfig record.
*/
function mapPropertiesToConfigs(properties) {
	const result = {};
	for (const [key, property] of Object.entries(properties)) result[key] = mapPropertyToConfig(property, key);
	return result;
}
/**
* Convert Rebase EnumValues to CollectionEnumValueConfig format.
* Handles both array form (EnumValueConfig[]) and record form.
*/
function mapEnumValues(enumValues) {
	if (!enumValues) return void 0;
	if (Array.isArray(enumValues)) {
		const result = {};
		for (const item of enumValues) result[String(item.id)] = normalizeEnumValueConfig(item);
		return result;
	}
	const result = {};
	for (const [key, value] of Object.entries(enumValues)) result[key] = typeof value === "string" ? value : normalizeEnumValueConfig(value);
	return result;
}
function normalizeEnumValueConfig(config) {
	return {
		label: config.label,
		color: typeof config.color === "string" ? config.color : void 0,
		disabled: config.disabled
	};
}
//#endregion
//#region src/util/dataControllerAdapter.ts
/**
* Adapts an `EntityTableController<M>` (from @rebasepro/types) to a
* `CollectionDataController<T>` (from @rebasepro/ui), bridging the
* entity-aware data layer to the headless collection view.
*/
/**
* Unwrap `Entity<M>` objects to flat rows for the headless view.
* The entity system uses `{ id, path, values: M }`; `values` is already the
* flat row `M` carrying its real primary key, so unwrapping is just `.values` —
* no `id`/`path` merge (those are view-model metadata, not row columns).
*/
function flattenEntities(entities) {
	return entities.map((entity) => entity.values);
}
/**
* React hook that adapts a EntityTableController to a CollectionDataController.
*
* Usage:
* ```tsx
* const tableController = useDataTableController({ path, collection });
* const dataController = useCollectionDataController(tableController);
*
* <CollectionView dataController={dataController} ... />
* ```
*/
function useCollectionDataController(tableController) {
	const flatData = useMemo(() => flattenEntities(tableController.data), [tableController.data]);
	return useMemo(() => ({
		data: flatData,
		loading: tableController.dataLoading,
		noMoreToLoad: tableController.noMoreToLoad,
		error: tableController.dataLoadingError,
		filterValues: tableController.filterValues,
		setFilterValues: tableController.setFilterValues,
		sortBy: tableController.sortBy,
		setSortBy: tableController.setSortBy,
		searchString: tableController.searchString,
		setSearchString: tableController.setSearchString,
		clearFilter: tableController.clearFilter,
		initialScroll: tableController.initialScroll,
		onScroll: tableController.onScroll,
		paginationEnabled: tableController.paginationEnabled,
		pageSize: tableController.pageSize,
		itemCount: tableController.itemCount,
		setItemCount: tableController.setItemCount
	}), [flatData, tableController]);
}
/**
* Non-hook version for cases where you already have the data
* and just need to build a static controller.
*/
function createStaticDataController(data, options) {
	return {
		data,
		loading: options?.loading ?? false,
		noMoreToLoad: true,
		error: options?.error
	};
}
//#endregion
//#region src/collection_editor/useJsonCollectionsConfigController.tsx
/**
* A `CollectionsConfigController` implementation that persists collection
* configurations as JSON via a pluggable `JsonCollectionStore` adapter.
*
* Use this when you want to store collection schemas in a database, API,
* localStorage, or any other JSON-compatible backend — as opposed to the
* default code-based persistence.
*
* @example
* ```tsx
* const store: JsonCollectionStore = {
*     load: async () => { const res = await fetch('/api/schemas'); return res.json(); },
*     save: async (slug, data) => { await fetch(`/api/schemas/${slug}`, { method: 'PUT', body: JSON.stringify(data) }); },
*     delete: async (slug) => { await fetch(`/api/schemas/${slug}`, { method: 'DELETE' }); },
* };
*
* const configController = useJsonCollectionsConfigController({ store });
* ```
*/
function useJsonCollectionsConfigController({ store, readOnly = false, autoLoad = true }) {
	const [collections, setCollections] = useState([]);
	const [loading, setLoading] = useState(autoLoad);
	const [navigationEntries, setNavigationEntries] = useState([]);
	const storeRef = useRef(store);
	storeRef.current = store;
	/**
	* The current collections, readable outside a state updater.
	*
	* Three mutators used to compute their new value inside
	* `setCollections(prev => …)` and persist from in there, which cost them
	* both halves of a save: the promise they returned resolved before the
	* store had answered, so a failed write reached the caller as a success,
	* and a `setState` updater must be pure — under `StrictMode` React invokes
	* it twice, so every one of those saves wrote to the store twice in
	* development. Reading `prev` from a ref lets them do what
	* `updatePropertiesOrder` already did: compute, set, then await.
	*/
	const collectionsRef = useRef([]);
	const applyCollections = useCallback((next) => {
		collectionsRef.current = next;
		setCollections(next);
	}, []);
	useEffect(() => {
		if (!autoLoad) return;
		let cancelled = false;
		(async () => {
			try {
				const [serialized, navEntries] = await Promise.all([storeRef.current.load(), storeRef.current.loadNavigationEntries?.() ?? Promise.resolve([])]);
				if (cancelled) return;
				applyCollections(fromSerializableCollectionConfigs(serialized));
				setNavigationEntries(navEntries);
			} catch (e) {
				console.error("useJsonCollectionsConfigController: failed to load collections", e);
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [autoLoad, applyCollections]);
	/**
	* Update local state and persist a collection to the store.
	*/
	const persistCollection = useCallback(async (collection) => {
		const serializable = toSerializableCollectionConfig(collection);
		await storeRef.current.save(collection.slug, serializable);
	}, []);
	/**
	* Find collection by id (slug).
	*/
	const getCollection = useCallback((id) => {
		const found = collections.find((c) => c.slug === id);
		if (found) return found;
		throw new Error(`Collection "${id}" not found`);
	}, [collections]);
	const saveCollection = useCallback(async ({ id, collectionData }) => {
		const collection = collectionData;
		await persistCollection(collection);
		const prev = collectionsRef.current;
		const idx = prev.findIndex((c) => c.slug === id);
		if (idx >= 0) {
			const next = [...prev];
			next[idx] = collection;
			applyCollections(next);
		} else applyCollections([...prev, collection]);
	}, [persistCollection, applyCollections]);
	const updateCollection = useCallback(async ({ id, collectionData, previousId }) => {
		const prev = collectionsRef.current;
		const lookupId = previousId ?? id;
		const idx = prev.findIndex((c) => c.slug === lookupId);
		if (idx < 0) return;
		const merged = {
			...prev[idx],
			...collectionData
		};
		const next = [...prev];
		next[idx] = merged;
		applyCollections(next);
		await persistCollection(merged);
		if (previousId && previousId !== id) await storeRef.current.delete(previousId);
	}, [persistCollection, applyCollections]);
	const deleteCollection = useCallback(async ({ id }) => {
		await storeRef.current.delete(id);
		applyCollections(collectionsRef.current.filter((c) => c.slug !== id));
	}, [applyCollections]);
	const saveProperty = useCallback(async ({ path, propertyKey, property, newPropertiesOrder }) => {
		const prev = collectionsRef.current;
		const idx = prev.findIndex((c) => c.slug === path);
		if (idx < 0) return;
		const collection = { ...prev[idx] };
		collection.properties = {
			...collection.properties,
			[propertyKey]: property
		};
		if (newPropertiesOrder) collection.propertiesOrder = newPropertiesOrder;
		const next = [...prev];
		next[idx] = collection;
		applyCollections(next);
		await persistCollection(next[idx]);
	}, [persistCollection, applyCollections]);
	const deleteProperty = useCallback(async ({ path, propertyKey, newPropertiesOrder }) => {
		const prev = collectionsRef.current;
		const idx = prev.findIndex((c) => c.slug === path);
		if (idx < 0) return;
		const collection = { ...prev[idx] };
		const { [propertyKey]: _removed, ...remaining } = collection.properties;
		collection.properties = remaining;
		if (newPropertiesOrder) collection.propertiesOrder = newPropertiesOrder;
		const next = [...prev];
		next[idx] = collection;
		applyCollections(next);
		await persistCollection(next[idx]);
	}, [persistCollection, applyCollections]);
	const updatePropertiesOrder = useCallback(async ({ collection, newPropertiesOrder }) => {
		const updated = {
			...collection,
			propertiesOrder: newPropertiesOrder
		};
		const prev = collectionsRef.current;
		const idx = prev.findIndex((c) => c.slug === collection.slug);
		if (idx >= 0) {
			const next = [...prev];
			next[idx] = updated;
			applyCollections(next);
		}
		await persistCollection(updated);
	}, [persistCollection, applyCollections]);
	const updateKanbanColumnsOrder = useCallback(async ({ collection, kanbanColumnProperty, newColumnsOrder }) => {}, []);
	const saveNavigationEntriesHandler = useCallback(async (entries) => {
		setNavigationEntries(entries);
		if (storeRef.current.saveNavigationEntries) await storeRef.current.saveNavigationEntries(entries);
	}, []);
	return useMemo(() => ({
		loading,
		readOnly,
		readOnlyReason: readOnly ? "Configuration is read-only." : void 0,
		collections,
		getCollection,
		saveCollection,
		updateCollection,
		deleteCollection,
		saveProperty,
		deleteProperty,
		updatePropertiesOrder,
		updateKanbanColumnsOrder,
		navigationEntries,
		saveNavigationEntries: saveNavigationEntriesHandler
	}), [
		loading,
		readOnly,
		collections,
		getCollection,
		saveCollection,
		updateCollection,
		deleteCollection,
		saveProperty,
		deleteProperty,
		updatePropertiesOrder,
		updateKanbanColumnsOrder,
		navigationEntries,
		saveNavigationEntriesHandler
	]);
}
//#endregion
//#region src/collection_editor/ui/MissingReferenceWidget.tsx
function MissingReferenceWidget({ path: pathProp }) {
	const registry = useCollectionRegistryController();
	const path = getLastSegment$1(pathProp);
	const parentCollectionSlugs = registry.getParentCollectionSlugs(pathProp);
	const parentEntityIds = registry.getParentEntityIds(pathProp);
	const collectionEditor = useCollectionEditorController();
	const { t } = useTranslation();
	return /* @__PURE__ */ jsxs("div", {
		className: "p-1 flex flex-col items-center",
		children: [/* @__PURE__ */ jsx(ErrorView, { error: t("studio_missing_reference_error", { path }) }), /* @__PURE__ */ jsx(Button, {
			className: "mx-2",
			size: "small",
			onClick: () => {
				collectionEditor.createCollection({
					initialValues: {
						path,
						name: prettifyIdentifier(path)
					},
					parentCollectionSlugs,
					parentEntityIds,
					redirect: false,
					sourceClick: "missing_reference"
				});
			},
			children: t("studio_missing_reference_create")
		})]
	});
}
//#endregion
export { AdminModeSyncer, AppBar, ArrayContainer, ArrayCustomShapedFieldBinding, ArrayEnumPreview, ArrayOfMapsPreview, ArrayOfReferencesFieldBinding, ArrayOfReferencesPreview, ArrayOfStorageComponentsPreview, ArrayOfStringsPreview, ArrayOneOfPreview, ArrayPropertyEnumPreview, ArrayPropertyPreview, BasicExportAction, BlockFieldBinding, BooleanPreview, CollectionCardViewBinding, CollectionGenerationApiError, CollectionPanel, CollectionRegistryContext, CollectionRowActions, CollectionTableBinding, CollectionViewActions, CollectionViewBinding, CreationResultDialog, CustomViewRoute, DEFAULT_COLLECTION_GENERATION_ENDPOINT, DEFAULT_FIELD_CONFIGS, DataNewPropertiesMapping, DatePreview, DateTimeFieldBinding, DefaultDrawer, Drawer, DrawerFooterActions, DrawerNavigationGroup, DrawerNavigationItem, EXPORT_PAGE_SIZE, EmptyValue, EntityCardBinding, EntityForm, EntityFormBinding, EntityPreviewBinding, EntityViewBinding, EnumValuesChip, ExportCollectionAction, FieldBlock, FieldCaption, FieldHelperText, FormRail, FormSections, IMPORT_BATCH_SIZE, ImagePreview, ImportCollectionAction, ImportDataPreview, ImportFileUpload, ImportNewPropertyFieldPreview, ImportSaveInProgress, InlineEntityListPreview, KeyValueFieldBinding, KeyValuePreview, LABEL_ICON_SIZE, LabelWithIcon, LiveSchemaError, MAX_EXPORT_ROWS, MAX_SELECTION_ROWS, MapFieldBinding, MapPropertyPreview, MarkdownEditorFieldBinding, MissingReferenceWidget, MultiSelectFieldBinding, NavigationStateContext, NumberPropertyPreview, PropertyConfigBadge, PropertyFieldBinding, PropertyKeyHint, PropertyPreview, PropertySelectEntry, ReadOnlyFieldBinding, RebaseAuthGate, RebaseCMS, RebaseLayout, RebaseNavigation, RebaseRoute, RebaseRouteDefs, RebaseShell, RecordMeta, ReferenceFieldBinding, ReferencePreview, ReferenceWidget, RelationPreview, RepeatFieldBinding, SELECTION_PAGE_SIZE, Scaffold, SchemaChangeCancelled, SearchIconsView, SelectFieldBinding, SelectableTable, SelectableTableContext, SelectionMenu, SelectionTableBinding, SideDialogs, SidePanelControllerContext, SidePanelProvider, SkeletonPropertyComponent, StorageThumbnail, StorageThumbnailInternal, StorageUploadFieldBinding, StringPropertyPreview, SwitchFieldBinding, TextFieldBinding, UrlComponentPreview, UrlContext, UserPreview, VectorFieldBinding, VirtualTableInput, addInitialSlash, asUnavailable, buildCollectionGenerationCallback, buildSidePanelsFromUrl, convertDataToEntity, convertFileToJson, copyEntityAction, createLiveSchemaClient, createStaticDataController, deleteEntityAction, detectCsvDelimiter, downloadBlob, downloadDataAsCsv, downloadEntitiesExport, editEntityAction, entryToCSVRow, escapeCsvFormula, extractTouchedValues, fetchAllEntitiesForExport, flattenEntry, fromSerializableCollectionConfig, fromSerializableCollectionConfigs, fromSerializableProperties, fromSerializableProperty, getBracketNotation, getChanges, getCollectionBySlugWithin, getCollectionPathsCombinations, getDefaultFieldConfig, getDefaultFieldId, getDefaultPropertiesOrder, getEntityCSVExportableData, getEntityJsonExportableData, getEntityPreviewKeys, getEntityTitlePropertyKey, getEntityTitlePropertyKeyForEntity, getEntityViewWidth, getFieldConfig, getFieldId, getFullId, getFullIdPath, getIconForProperty, getIconForWidget, getInferenceType, getInitialEntityValues, getLastSegment, getPropertiesWithPropertiesOrder, getPropertyInPath, getResolvedPropertyInPath, getUserLabel, idToPropertiesPath, isReferenceProperty, isRelationProperty, isSchemaChangeCancelled, isSelfLabellingProperty, mapPropertiesToConfigs, mapPropertyToConfig, mergeEntityActions, namespaceToPropertiesOrderPath, namespaceToPropertiesPath, parseCsvRows, parseCsvToObjects, processValueMapping, removeEmptyContainers, removeInitialAndTrailingSlashes, removeInitialSlash, removeTrailingSlash, renderSkeletonCaptionText, renderSkeletonIcon, renderSkeletonImageThumbnail, renderSkeletonText, resetPasswordAction, resolveCollectionPathIds, resolveEntityAction, resolveEntityView, resolveNavigationFrom, resolveSelection, sanitizeUrl, saveImportedEntities, selectionQueryToFindParams, serializeSelectionQuery, spanClass, toSerializableCollectionConfig, toSerializableProperties, toSerializableProperty, useAdminContext, useApp, useBreadcrumbsController, useBuildCollectionRegistryController, useBuildNavigationStateController, useBuildSidePanel, useBuildUrlController, useClearRestoreValue, useCollectionDataController, useCollectionEditorController, useCollectionRegistryController, useCollectionsConfigController, useHistory, useImportConfig, useJsonCollectionsConfigController, useLiveSchemaEditing, useLocalCollectionsConfigController, useNavigationStateController, useResolvedCollections, useResolvedNavigationFrom, useResolvedUser, useResolvedViews, useSelectionController, useSelectionDialog, useSideDialogsController, useSidePanel, useTopLevelNavigation, useUrlController, validateCollectionJson, zodToFormErrors };

//# sourceMappingURL=index.js.map